// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AccountingInvoicePaymentRequestsCreateData, AccountingInvoicePaymentRequestsCreateErrors, AccountingInvoicePaymentRequestsCreateResponses, AccountingInvoicePaymentRequestsGetData, AccountingInvoicePaymentRequestsGetErrors, AccountingInvoicePaymentRequestsGetResponses, AnalyticsRevenueMrrSummaryData, AnalyticsRevenueMrrSummaryResponses, AnalyticsRevenueTimeSeriesData, AnalyticsRevenueTimeSeriesResponses, CartApiKeysEnsureData, CartApiKeysEnsureErrors, CartApiKeysEnsureResponses, CartApiKeysRotateData, CartApiKeysRotateErrors, CartApiKeysRotateResponses, CartApiKeysStatusData, CartApiKeysStatusErrors, CartApiKeysStatusResponses, CartSessionsAddLineItemData, CartSessionsAddLineItemErrors, CartSessionsAddLineItemResponses, CartSessionsApplyDiscountCodeData, CartSessionsApplyDiscountCodeErrors, CartSessionsApplyDiscountCodeResponses, CartSessionsConvertData, CartSessionsConvertErrors, CartSessionsConvertResponses, CartSessionsCreateData, CartSessionsCreateErrors, CartSessionsCreateResponses, CartSessionsGetData, CartSessionsGetErrors, CartSessionsGetResponses, CartSessionsRemoveLineItemData, CartSessionsRemoveLineItemErrors, CartSessionsRemoveLineItemResponses, CartSessionsSetContactData, CartSessionsSetContactErrors, CartSessionsSetContactResponses, CartSessionsToggleAddOnData, CartSessionsToggleAddOnErrors, CartSessionsToggleAddOnResponses, CartSessionsUpdateLineItemData, CartSessionsUpdateLineItemErrors, CartSessionsUpdateLineItemResponses, CheckoutSessionsCreateData, CheckoutSessionsCreateErrors, CheckoutSessionsCreateResponses, CheckoutSessionsExpireData, CheckoutSessionsExpireErrors, CheckoutSessionsExpireResponses, CheckoutSessionsGetData, CheckoutSessionsGetErrors, CheckoutSessionsGetResponses, CreditNotesCreateData, CreditNotesCreateErrors, CreditNotesCreateResponses, CreditNotesGetData, CreditNotesGetErrors, CreditNotesGetResponses, CreditNotesListData, CreditNotesListErrors, CreditNotesListLinesData, CreditNotesListLinesErrors, CreditNotesListLinesResponses, CreditNotesListResponses, CreditNotesPreviewData, CreditNotesPreviewErrors, CreditNotesPreviewResponses, CreditNotesVoidData, CreditNotesVoidErrors, CreditNotesVoidResponses, CustomerMetersGetData, CustomerMetersGetErrors, CustomerMetersGetResponses, CustomerMetersListData, CustomerMetersListErrors, CustomerMetersListResponses, CustomerPortalCustomerGetData, CustomerPortalCustomerGetErrors, CustomerPortalCustomerGetResponses, CustomerPortalInvoicesGetData, CustomerPortalInvoicesGetErrors, CustomerPortalInvoicesGetResponses, CustomerPortalInvoicesListData, CustomerPortalInvoicesListErrors, CustomerPortalInvoicesListResponses, CustomerPortalMandatesCancelData, CustomerPortalMandatesCancelErrors, CustomerPortalMandatesCancelResponses, CustomerPortalMandatesListData, CustomerPortalMandatesListErrors, CustomerPortalMandatesListResponses, CustomerPortalMandatesReauthorizeData, CustomerPortalMandatesReauthorizeErrors, CustomerPortalMandatesReauthorizeResponses, CustomerPortalMandatesReauthorizeSendOtpData, CustomerPortalMandatesReauthorizeSendOtpErrors, CustomerPortalMandatesReauthorizeSendOtpResponses, CustomerPortalMandatesReauthorizeVerifyOtpData, CustomerPortalMandatesReauthorizeVerifyOtpErrors, CustomerPortalMandatesReauthorizeVerifyOtpResponses, CustomerPortalSessionsCreateData, CustomerPortalSessionsCreateErrors, CustomerPortalSessionsCreateResponses, CustomerPortalSubscriptionsCancelData, CustomerPortalSubscriptionsCancelErrors, CustomerPortalSubscriptionsCancelResponses, CustomerPortalSubscriptionsGetData, CustomerPortalSubscriptionsGetErrors, CustomerPortalSubscriptionsGetResponses, CustomerPortalSubscriptionsListData, CustomerPortalSubscriptionsListErrors, CustomerPortalSubscriptionsListResponses, CustomersCreateData, CustomersCreateErrors, CustomersCreateResponses, CustomersGetData, CustomersGetErrors, CustomersGetResponses, CustomersListData, CustomersListErrors, CustomersListResponses, CustomersPaymentMethodsListData, CustomersPaymentMethodsListErrors, CustomersPaymentMethodsListResponses, CustomersPaymentRailsGetData, CustomersPaymentRailsGetErrors, CustomersPaymentRailsGetResponses, CustomersPreferredRailsGetData, CustomersPreferredRailsGetErrors, CustomersPreferredRailsGetResponses, CustomersUpdateData, CustomersUpdateErrors, CustomersUpdateResponses, DdMandateRequestsGetData, DdMandateRequestsGetErrors, DdMandateRequestsGetResponses, DdPreviewData, DdPreviewErrors, DdPreviewResponses, DdValidateData, DdValidateErrors, DdValidateResponses, EntitlementsCheckData, EntitlementsCheckErrors, EntitlementsCheckResponses, EntitlementsListData, EntitlementsListErrors, EntitlementsListResponses, EventsGetData, EventsGetErrors, EventsGetResponses, EventsListData, EventsListErrors, EventsListResponses, EventsResendData, EventsResendErrors, EventsResendResponses, InvoicesCreateData, InvoicesCreateResponses, InvoicesFinalizeData, InvoicesFinalizeErrors, InvoicesFinalizeResponses, InvoicesGetData, InvoicesGetResponses, InvoicesListData, InvoicesListResponses, InvoicesMarginEstimateData, InvoicesMarginEstimateErrors, InvoicesMarginEstimateResponses, InvoicesSendData, InvoicesSendErrors, InvoicesSendResponses, InvoicesUpdateData, InvoicesUpdateResponses, InvoicesVoidData, InvoicesVoidErrors, InvoicesVoidResponses, MandatesCancelData, MandatesCancelErrors, MandatesCancelResponses, MandatesCreateData, MandatesCreateErrors, MandatesCreateResponses, MandatesGetData, MandatesGetErrors, MandatesGetResponses, MandatesListData, MandatesListErrors, MandatesListResponses, MandatesReinstateData, MandatesReinstateErrors, MandatesReinstateResponses, MandatesScheduleCollectionData, MandatesScheduleCollectionErrors, MandatesScheduleCollectionResponses, MandatesSuspendData, MandatesSuspendErrors, MandatesSuspendResponses, PaymentIntentsCancelData, PaymentIntentsCancelErrors, PaymentIntentsCancelResponses, PaymentIntentsCaptureData, PaymentIntentsCaptureErrors, PaymentIntentsCaptureResponses, PaymentIntentsConfirmData, PaymentIntentsConfirmErrors, PaymentIntentsConfirmResponses, PaymentIntentsCreateData, PaymentIntentsCreateErrors, PaymentIntentsCreateResponses, PaymentIntentsGetData, PaymentIntentsGetErrors, PaymentIntentsGetResponses, PaymentIntentsListData, PaymentIntentsListErrors, PaymentIntentsListResponses, PaymentLinksActivateData, PaymentLinksActivateErrors, PaymentLinksActivateResponses, PaymentLinksArchiveData, PaymentLinksArchiveErrors, PaymentLinksArchiveResponses, PaymentLinksCreateData, PaymentLinksCreateErrors, PaymentLinksCreateResponses, PaymentLinksDeactivateData, PaymentLinksDeactivateErrors, PaymentLinksDeactivateResponses, PaymentLinksExpireData, PaymentLinksExpireErrors, PaymentLinksExpireResponses, PaymentLinksGetData, PaymentLinksGetErrors, PaymentLinksGetResponses, PaymentLinksListData, PaymentLinksListErrors, PaymentLinksListResponses, PaymentLinksUpdateData, PaymentLinksUpdateErrors, PaymentLinksUpdateResponses, PricesArchiveData, PricesArchiveErrors, PricesArchiveResponses, PricesCreateData, PricesCreateErrors, PricesCreateResponses, PricesGetData, PricesGetErrors, PricesGetResponses, PricesListData, PricesListErrors, PricesListResponses, PricesUpdateData, PricesUpdateErrors, PricesUpdateResponses, ProductsCreateData, ProductsCreateErrors, ProductsCreateResponses, ProductsGetData, ProductsGetErrors, ProductsGetResponses, ProductsListData, ProductsListErrors, ProductsListResponses, ProductsUpdateData, ProductsUpdateErrors, ProductsUpdateResponses, RefundsCreateData, RefundsCreateErrors, RefundsCreateResponses, RefundsGetData, RefundsGetErrors, RefundsGetResponses, RefundsListData, RefundsListErrors, RefundsListResponses, StorefrontOriginsCreateData, StorefrontOriginsCreateErrors, StorefrontOriginsCreateResponses, StorefrontOriginsDeleteData, StorefrontOriginsDeleteErrors, StorefrontOriginsDeleteResponses, StorefrontOriginsListData, StorefrontOriginsListErrors, StorefrontOriginsListResponses, StorefrontProductsGetData, StorefrontProductsGetErrors, StorefrontProductsGetResponses, StorefrontProductsListData, StorefrontProductsListErrors, StorefrontProductsListResponses, StorefrontStatusGetData, StorefrontStatusGetErrors, StorefrontStatusGetResponses, SubscriptionsCancelData, SubscriptionsCancelErrors, SubscriptionsCancelResponses, SubscriptionsCreateData, SubscriptionsCreateErrors, SubscriptionsCreateResponses, SubscriptionsGetData, SubscriptionsGetErrors, SubscriptionsGetResponses, SubscriptionsListData, SubscriptionsListErrors, SubscriptionsListResponses, SubscriptionsUpdateData, SubscriptionsUpdateErrors, SubscriptionsUpdateResponses, TransactionsGetData, TransactionsGetErrors, TransactionsGetResponses, TransactionsListData, TransactionsListErrors, TransactionsListResponses, WebhookDeliveriesGetData, WebhookDeliveriesGetErrors, WebhookDeliveriesGetResponses, WebhookDeliveriesListData, WebhookDeliveriesListErrors, WebhookDeliveriesListResponses, WebhookDeliveriesRetryData, WebhookDeliveriesRetryErrors, WebhookDeliveriesRetryResponses, WebhookEndpointsCreateData, WebhookEndpointsCreateErrors, WebhookEndpointsCreateResponses, WebhookEndpointsDeleteData, WebhookEndpointsDeleteErrors, WebhookEndpointsDeleteResponses, WebhookEndpointsGetData, WebhookEndpointsGetErrors, WebhookEndpointsGetResponses, WebhookEndpointsListData, WebhookEndpointsListErrors, WebhookEndpointsListResponses, WebhookEndpointsRotateSecretData, WebhookEndpointsRotateSecretErrors, WebhookEndpointsRotateSecretResponses, WebhookEndpointsUpdateData, WebhookEndpointsUpdateErrors, WebhookEndpointsUpdateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List invoices
 *
 * List invoices with pagination and filtering.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `PUT /invoices/external/batch` — Batch upsert invoices by external ID
 * - `POST /invoices` — Create invoice
 * - `GET /invoices/{id}` — Get invoice
 * - `PATCH /invoices/{id}` — Update invoice
 * - `DELETE /invoices/{id}` — Delete invoice
 * - `POST /invoices/{id}/margin-estimate` — Estimate invoice net by payment rail
 * - `POST /invoices/{id}/refund` — Refund invoice
 * - `POST /invoices/{id}/reject` — Reject invoice
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const invoicesList = <ThrowOnError extends boolean = false>(options?: Options<InvoicesListData, ThrowOnError>) => (options?.client ?? client).get<InvoicesListResponses, unknown, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/invoices',
    ...options
});

/**
 * Create invoice
 *
 * Create a new invoice.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `PUT /invoices/external/batch` — Batch upsert invoices by external ID
 * - `GET /invoices` — List invoices
 * - `GET /invoices/{id}` — Get invoice
 * - `PATCH /invoices/{id}` — Update invoice
 * - `DELETE /invoices/{id}` — Delete invoice
 * - `POST /invoices/{id}/margin-estimate` — Estimate invoice net by payment rail
 * - `POST /invoices/{id}/refund` — Refund invoice
 * - `POST /invoices/{id}/reject` — Reject invoice
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const invoicesCreate = <ThrowOnError extends boolean = false>(options: Options<InvoicesCreateData, ThrowOnError>) => (options.client ?? client).post<InvoicesCreateResponses, unknown, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/invoices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get invoice
 *
 * Get a single invoice by ID.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `PUT /invoices/external/batch` — Batch upsert invoices by external ID
 * - `GET /invoices` — List invoices
 * - `POST /invoices` — Create invoice
 * - `PATCH /invoices/{id}` — Update invoice
 * - `DELETE /invoices/{id}` — Delete invoice
 * - `POST /invoices/{id}/margin-estimate` — Estimate invoice net by payment rail
 * - `POST /invoices/{id}/refund` — Refund invoice
 * - `POST /invoices/{id}/reject` — Reject invoice
 */
export const invoicesGet = <ThrowOnError extends boolean = false>(options: Options<InvoicesGetData, ThrowOnError>) => (options.client ?? client).get<InvoicesGetResponses, unknown, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/invoices/{id}',
    ...options
});

/**
 * Update invoice
 *
 * Update an existing invoice.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `PUT /invoices/external/batch` — Batch upsert invoices by external ID
 * - `GET /invoices` — List invoices
 * - `POST /invoices` — Create invoice
 * - `GET /invoices/{id}` — Get invoice
 * - `DELETE /invoices/{id}` — Delete invoice
 * - `POST /invoices/{id}/margin-estimate` — Estimate invoice net by payment rail
 * - `POST /invoices/{id}/refund` — Refund invoice
 * - `POST /invoices/{id}/reject` — Reject invoice
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const invoicesUpdate = <ThrowOnError extends boolean = false>(options: Options<InvoicesUpdateData, ThrowOnError>) => (options.client ?? client).patch<InvoicesUpdateResponses, unknown, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/invoices/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Estimate invoice net by payment rail
 *
 * Estimate per-rail processing fees and net-after-fees for an invoice amount.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `PUT /invoices/external/batch` — Batch upsert invoices by external ID
 * - `GET /invoices` — List invoices
 * - `POST /invoices` — Create invoice
 * - `GET /invoices/{id}` — Get invoice
 * - `PATCH /invoices/{id}` — Update invoice
 * - `DELETE /invoices/{id}` — Delete invoice
 * - `POST /invoices/{id}/refund` — Refund invoice
 * - `POST /invoices/{id}/reject` — Reject invoice
 *
 * **Common errors**
 *
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const invoicesMarginEstimate = <ThrowOnError extends boolean = false>(options: Options<InvoicesMarginEstimateData, ThrowOnError>) => (options.client ?? client).post<InvoicesMarginEstimateResponses, InvoicesMarginEstimateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/invoices/{id}/margin-estimate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finalize an invoice
 *
 * Finalizes a draft invoice, locking it for payment. Assigns invoice number and generates public token. After finalization, financial fields become immutable.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `PUT /invoices/external/batch` — Batch upsert invoices by external ID
 * - `GET /invoices` — List invoices
 * - `POST /invoices` — Create invoice
 * - `GET /invoices/{id}` — Get invoice
 * - `PATCH /invoices/{id}` — Update invoice
 * - `DELETE /invoices/{id}` — Delete invoice
 * - `POST /invoices/{id}/margin-estimate` — Estimate invoice net by payment rail
 * - `POST /invoices/{id}/refund` — Refund invoice
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const invoicesFinalize = <ThrowOnError extends boolean = false>(options: Options<InvoicesFinalizeData, ThrowOnError>) => (options.client ?? client).post<InvoicesFinalizeResponses, InvoicesFinalizeErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/invoices/{id}/finalize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Void an invoice
 *
 * Voids an invoice. Only invoices without recorded payments can be voided. Use refund instead for paid invoices.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `PUT /invoices/external/batch` — Batch upsert invoices by external ID
 * - `GET /invoices` — List invoices
 * - `POST /invoices` — Create invoice
 * - `GET /invoices/{id}` — Get invoice
 * - `PATCH /invoices/{id}` — Update invoice
 * - `DELETE /invoices/{id}` — Delete invoice
 * - `POST /invoices/{id}/margin-estimate` — Estimate invoice net by payment rail
 * - `POST /invoices/{id}/refund` — Refund invoice
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const invoicesVoid = <ThrowOnError extends boolean = false>(options: Options<InvoicesVoidData, ThrowOnError>) => (options.client ?? client).post<InvoicesVoidResponses, InvoicesVoidErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/invoices/{id}/void',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send an invoice
 *
 * Sends an invoice to the customer via the specified channel (email, SMS, or WhatsApp). Invoice must be approved first.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `PUT /invoices/external/batch` — Batch upsert invoices by external ID
 * - `GET /invoices` — List invoices
 * - `POST /invoices` — Create invoice
 * - `GET /invoices/{id}` — Get invoice
 * - `PATCH /invoices/{id}` — Update invoice
 * - `DELETE /invoices/{id}` — Delete invoice
 * - `POST /invoices/{id}/margin-estimate` — Estimate invoice net by payment rail
 * - `POST /invoices/{id}/refund` — Refund invoice
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const invoicesSend = <ThrowOnError extends boolean = false>(options: Options<InvoicesSendData, ThrowOnError>) => (options.client ?? client).post<InvoicesSendResponses, InvoicesSendErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/invoices/{id}/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List products
 *
 * List products with pagination and optional search.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /products` — Create product
 * - `GET /products/{id}` — Get product by ID
 * - `PATCH /products/{id}` — Update product
 * - `PUT /products/external/{source}/{externalId}` — Upsert product by external ID
 * - `PUT /products/external/batch` — Batch upsert products by external ID
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const productsList = <ThrowOnError extends boolean = false>(options?: Options<ProductsListData, ThrowOnError>) => (options?.client ?? client).get<ProductsListResponses, ProductsListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/products',
    ...options
});

/**
 * Create product
 *
 * Create a new product. Requires 'products:write' scope.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /products` — List products
 * - `GET /products/{id}` — Get product by ID
 * - `PATCH /products/{id}` — Update product
 * - `PUT /products/external/{source}/{externalId}` — Upsert product by external ID
 * - `PUT /products/external/batch` — Batch upsert products by external ID
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const productsCreate = <ThrowOnError extends boolean = false>(options: Options<ProductsCreateData, ThrowOnError>) => (options.client ?? client).post<ProductsCreateResponses, ProductsCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get product by ID
 *
 * Get a product by its ID. Requires 'products:read' scope.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /products` — List products
 * - `POST /products` — Create product
 * - `PATCH /products/{id}` — Update product
 * - `PUT /products/external/{source}/{externalId}` — Upsert product by external ID
 * - `PUT /products/external/batch` — Batch upsert products by external ID
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const productsGet = <ThrowOnError extends boolean = false>(options: Options<ProductsGetData, ThrowOnError>) => (options.client ?? client).get<ProductsGetResponses, ProductsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/products/{id}',
    ...options
});

/**
 * Update product
 *
 * Update an existing product. Requires 'products:write' scope.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /products` — List products
 * - `POST /products` — Create product
 * - `GET /products/{id}` — Get product by ID
 * - `PUT /products/external/{source}/{externalId}` — Upsert product by external ID
 * - `PUT /products/external/batch` — Batch upsert products by external ID
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const productsUpdate = <ThrowOnError extends boolean = false>(options: Options<ProductsUpdateData, ThrowOnError>) => (options.client ?? client).patch<ProductsUpdateResponses, ProductsUpdateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/products/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a checkout session
 *
 * Create a checkout session for an invoice or product.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /checkout-sessions/{id}` — Retrieve a checkout session
 * - `POST /checkout-sessions/{id}/expire` — Expire a checkout session
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const checkoutSessionsCreate = <ThrowOnError extends boolean = false>(options?: Options<CheckoutSessionsCreateData, ThrowOnError>) => (options?.client ?? client).post<CheckoutSessionsCreateResponses, CheckoutSessionsCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/checkout-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Retrieve a checkout session
 *
 * Retrieve a checkout session by its ID.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /checkout-sessions` — Create a checkout session
 * - `POST /checkout-sessions/{id}/expire` — Expire a checkout session
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const checkoutSessionsGet = <ThrowOnError extends boolean = false>(options: Options<CheckoutSessionsGetData, ThrowOnError>) => (options.client ?? client).get<CheckoutSessionsGetResponses, CheckoutSessionsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/checkout-sessions/{id}',
    ...options
});

/**
 * Expire a checkout session
 *
 * Manually expire an open checkout session. Only sessions with status 'open' or 'pending' and no active payment attempt can be expired.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /checkout-sessions` — Create a checkout session
 * - `GET /checkout-sessions/{id}` — Retrieve a checkout session
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const checkoutSessionsExpire = <ThrowOnError extends boolean = false>(options: Options<CheckoutSessionsExpireData, ThrowOnError>) => (options.client ?? client).post<CheckoutSessionsExpireResponses, CheckoutSessionsExpireErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/checkout-sessions/{id}/expire',
    ...options
});

/**
 * Create a cart session
 *
 * Create an empty (or pre-populated) cart session. The returned cart is `open` and mutable until it is converted into a checkout session, or until it is swept to `abandoned` / `expired`.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /cart-sessions/{id}` — Retrieve a cart session
 * - `POST /cart-sessions/{id}/convert` — Convert to a checkout session
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /cart-sessions/{id}` — Retrieve a cart session
 * - `POST /cart-sessions/{id}/line-items` — Add a line item to a cart session
 * - `PATCH /cart-sessions/{id}/line-items/{lineId}` — Update a line item's quantity
 * - `DELETE /cart-sessions/{id}/line-items/{lineId}` — Remove a line item from a cart session
 * - `POST /cart-sessions/{id}/add-ons` — Toggle an add-on on a cart session
 * - `POST /cart-sessions/{id}/discount-code` — Set or clear a cart discount code
 * - `POST /cart-sessions/{id}/contact` — Capture customer email + consent on a cart
 * - `POST /cart-sessions/{id}/convert` — Convert a cart session into a checkout session
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `422 unprocessable_entity` — business-rule failure (for example, refunding more than the original charge).
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const cartSessionsCreate = <ThrowOnError extends boolean = false>(options?: Options<CartSessionsCreateData, ThrowOnError>) => (options?.client ?? client).post<CartSessionsCreateResponses, CartSessionsCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/cart-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Retrieve a cart session
 *
 * Fetch the current state of a cart session by id. Returns the same shape as the create response.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /cart-sessions` — Create a cart session
 * - `POST /cart-sessions/{id}/line-items` — Add a line item to a cart session
 * - `PATCH /cart-sessions/{id}/line-items/{lineId}` — Update a line item's quantity
 * - `DELETE /cart-sessions/{id}/line-items/{lineId}` — Remove a line item from a cart session
 * - `POST /cart-sessions/{id}/add-ons` — Toggle an add-on on a cart session
 * - `POST /cart-sessions/{id}/discount-code` — Set or clear a cart discount code
 * - `POST /cart-sessions/{id}/contact` — Capture customer email + consent on a cart
 * - `POST /cart-sessions/{id}/convert` — Convert a cart session into a checkout session
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const cartSessionsGet = <ThrowOnError extends boolean = false>(options: Options<CartSessionsGetData, ThrowOnError>) => (options.client ?? client).get<CartSessionsGetResponses, CartSessionsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/cart-sessions/{id}',
    ...options
});

/**
 * Add a line item to a cart session
 *
 * Append a line item to an open cart session. Subtotals are recomputed atomically; the updated cart is returned.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /cart-sessions` — Create a cart session
 * - `GET /cart-sessions/{id}` — Retrieve a cart session
 * - `PATCH /cart-sessions/{id}/line-items/{lineId}` — Update a line item's quantity
 * - `DELETE /cart-sessions/{id}/line-items/{lineId}` — Remove a line item from a cart session
 * - `POST /cart-sessions/{id}/add-ons` — Toggle an add-on on a cart session
 * - `POST /cart-sessions/{id}/discount-code` — Set or clear a cart discount code
 * - `POST /cart-sessions/{id}/contact` — Capture customer email + consent on a cart
 * - `POST /cart-sessions/{id}/convert` — Convert a cart session into a checkout session
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const cartSessionsAddLineItem = <ThrowOnError extends boolean = false>(options: Options<CartSessionsAddLineItemData, ThrowOnError>) => (options.client ?? client).post<CartSessionsAddLineItemResponses, CartSessionsAddLineItemErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/cart-sessions/{id}/line-items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a line item from a cart session
 *
 * Remove a line item from an open cart. Subtotals are recomputed; the updated cart is returned.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /cart-sessions` — Create a cart session
 * - `GET /cart-sessions/{id}` — Retrieve a cart session
 * - `POST /cart-sessions/{id}/line-items` — Add a line item to a cart session
 * - `PATCH /cart-sessions/{id}/line-items/{lineId}` — Update a line item's quantity
 * - `POST /cart-sessions/{id}/add-ons` — Toggle an add-on on a cart session
 * - `POST /cart-sessions/{id}/discount-code` — Set or clear a cart discount code
 * - `POST /cart-sessions/{id}/contact` — Capture customer email + consent on a cart
 * - `POST /cart-sessions/{id}/convert` — Convert a cart session into a checkout session
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const cartSessionsRemoveLineItem = <ThrowOnError extends boolean = false>(options: Options<CartSessionsRemoveLineItemData, ThrowOnError>) => (options.client ?? client).delete<CartSessionsRemoveLineItemResponses, CartSessionsRemoveLineItemErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/cart-sessions/{id}/line-items/{lineId}',
    ...options
});

/**
 * Update a line item's quantity
 *
 * Change the quantity of a single line item on an open cart. Other fields on the line item are immutable; recreate the item to change them.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /cart-sessions` — Create a cart session
 * - `GET /cart-sessions/{id}` — Retrieve a cart session
 * - `POST /cart-sessions/{id}/line-items` — Add a line item to a cart session
 * - `DELETE /cart-sessions/{id}/line-items/{lineId}` — Remove a line item from a cart session
 * - `POST /cart-sessions/{id}/add-ons` — Toggle an add-on on a cart session
 * - `POST /cart-sessions/{id}/discount-code` — Set or clear a cart discount code
 * - `POST /cart-sessions/{id}/contact` — Capture customer email + consent on a cart
 * - `POST /cart-sessions/{id}/convert` — Convert a cart session into a checkout session
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const cartSessionsUpdateLineItem = <ThrowOnError extends boolean = false>(options: Options<CartSessionsUpdateLineItemData, ThrowOnError>) => (options.client ?? client).patch<CartSessionsUpdateLineItemResponses, CartSessionsUpdateLineItemErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/cart-sessions/{id}/line-items/{lineId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Toggle an add-on on a cart session
 *
 * Add or remove an add-on product from `add_ons_selected`. The call is idempotent: sending the same desired state for an add-on already in that state is a no-op and emits no event.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /cart-sessions` — Create a cart session
 * - `GET /cart-sessions/{id}` — Retrieve a cart session
 * - `POST /cart-sessions/{id}/line-items` — Add a line item to a cart session
 * - `PATCH /cart-sessions/{id}/line-items/{lineId}` — Update a line item's quantity
 * - `DELETE /cart-sessions/{id}/line-items/{lineId}` — Remove a line item from a cart session
 * - `POST /cart-sessions/{id}/discount-code` — Set or clear a cart discount code
 * - `POST /cart-sessions/{id}/contact` — Capture customer email + consent on a cart
 * - `POST /cart-sessions/{id}/convert` — Convert a cart session into a checkout session
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const cartSessionsToggleAddOn = <ThrowOnError extends boolean = false>(options: Options<CartSessionsToggleAddOnData, ThrowOnError>) => (options.client ?? client).post<CartSessionsToggleAddOnResponses, CartSessionsToggleAddOnErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/cart-sessions/{id}/add-ons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set or clear a cart discount code
 *
 * Set the cart's discount code. Pass `null` to clear. The code is validated against the merchant's active discounts and priced into the cart total immediately; convert then carries the discounted amount.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /cart-sessions` — Create a cart session
 * - `GET /cart-sessions/{id}` — Retrieve a cart session
 * - `POST /cart-sessions/{id}/line-items` — Add a line item to a cart session
 * - `PATCH /cart-sessions/{id}/line-items/{lineId}` — Update a line item's quantity
 * - `DELETE /cart-sessions/{id}/line-items/{lineId}` — Remove a line item from a cart session
 * - `POST /cart-sessions/{id}/add-ons` — Toggle an add-on on a cart session
 * - `POST /cart-sessions/{id}/contact` — Capture customer email + consent on a cart
 * - `POST /cart-sessions/{id}/convert` — Convert a cart session into a checkout session
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const cartSessionsApplyDiscountCode = <ThrowOnError extends boolean = false>(options: Options<CartSessionsApplyDiscountCodeData, ThrowOnError>) => (options.client ?? client).post<CartSessionsApplyDiscountCodeResponses, CartSessionsApplyDiscountCodeErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/cart-sessions/{id}/discount-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Capture customer email + consent on a cart
 *
 * Capture the customer's email and marketing/recovery consent on an open cart so an abandoned cart can be recovered (REV-5517). Every field is optional; pass `null` to clear. Setting a field records its consent/capture timestamp. Idempotent — an input that changes nothing is a no-op.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /cart-sessions` — Create a cart session
 * - `GET /cart-sessions/{id}` — Retrieve a cart session
 * - `POST /cart-sessions/{id}/line-items` — Add a line item to a cart session
 * - `PATCH /cart-sessions/{id}/line-items/{lineId}` — Update a line item's quantity
 * - `DELETE /cart-sessions/{id}/line-items/{lineId}` — Remove a line item from a cart session
 * - `POST /cart-sessions/{id}/add-ons` — Toggle an add-on on a cart session
 * - `POST /cart-sessions/{id}/discount-code` — Set or clear a cart discount code
 * - `POST /cart-sessions/{id}/convert` — Convert a cart session into a checkout session
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const cartSessionsSetContact = <ThrowOnError extends boolean = false>(options: Options<CartSessionsSetContactData, ThrowOnError>) => (options.client ?? client).post<CartSessionsSetContactResponses, CartSessionsSetContactErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/cart-sessions/{id}/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Convert a cart session into a checkout session
 *
 * Atomically materialise a pending checkout session from the cart snapshot, reserve tracked availability, flip the cart to `converted`, and emit `commerce.cart.converted` + `commerce.checkout.started` through the outbox.
 *
 * Idempotent on re-call (returns the existing checkout session). Concurrency-safe via a compare-and-swap lock on cart status; product availability is guarded by the database reserve step.
 *
 * Validation that runs inside the lock and rolls back on failure:
 * - `CART_SESSION_EMPTY` — the cart has no line items.
 * - `AVAILABILITY_EXCEEDED` — a tracked/capacity-limited product can no longer satisfy the requested quantity.
 * - `CART_SESSION_NOT_FOUND` — no cart for this id under the calling merchant.
 * - `CART_SESSION_CLOSED` — the cart is already `abandoned` or `expired`.
 *
 * On rollback the cart returns to `open` and the customer can retry after fixing the cause.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /cart-sessions` — Create a cart session
 * - `GET /cart-sessions/{id}` — Retrieve a cart session
 * - `POST /cart-sessions/{id}/line-items` — Add a line item to a cart session
 * - `PATCH /cart-sessions/{id}/line-items/{lineId}` — Update a line item's quantity
 * - `DELETE /cart-sessions/{id}/line-items/{lineId}` — Remove a line item from a cart session
 * - `POST /cart-sessions/{id}/add-ons` — Toggle an add-on on a cart session
 * - `POST /cart-sessions/{id}/discount-code` — Set or clear a cart discount code
 * - `POST /cart-sessions/{id}/contact` — Capture customer email + consent on a cart
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const cartSessionsConvert = <ThrowOnError extends boolean = false>(options: Options<CartSessionsConvertData, ThrowOnError>) => (options.client ?? client).post<CartSessionsConvertResponses, CartSessionsConvertErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/cart-sessions/{id}/convert',
    ...options
});

/**
 * Get managed Cart API key status
 *
 * Returns whether the authenticated merchant has managed RevKeen Cart publishable and secret keys. Existing key values are never returned.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /cart-api-keys/ensure` — Ensure managed Cart API keys exist
 * - `POST /cart-api-keys/{kind}/rotate` — Rotate a managed Cart API key
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 */
export const cartApiKeysStatus = <ThrowOnError extends boolean = false>(options?: Options<CartApiKeysStatusData, ThrowOnError>) => (options?.client ?? client).get<CartApiKeysStatusResponses, CartApiKeysStatusErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/cart-api-keys/status',
    ...options
});

/**
 * Ensure managed Cart API keys exist
 *
 * Creates any missing managed RevKeen Cart publishable and secret keys for the authenticated merchant. Newly created key values are returned once; existing secret values are never re-exposed.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /cart-api-keys/status` — Get managed Cart API key status
 * - `POST /cart-api-keys/{kind}/rotate` — Rotate a managed Cart API key
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const cartApiKeysEnsure = <ThrowOnError extends boolean = false>(options?: Options<CartApiKeysEnsureData, ThrowOnError>) => (options?.client ?? client).post<CartApiKeysEnsureResponses, CartApiKeysEnsureErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/cart-api-keys/ensure',
    ...options
});

/**
 * Rotate a managed Cart API key
 *
 * Rotates the managed RevKeen Cart publishable or secret key. The new key value is returned once; previous keys remain valid for the requested grace window.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /cart-api-keys/status` — Get managed Cart API key status
 * - `POST /cart-api-keys/ensure` — Ensure managed Cart API keys exist
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const cartApiKeysRotate = <ThrowOnError extends boolean = false>(options: Options<CartApiKeysRotateData, ThrowOnError>) => (options.client ?? client).post<CartApiKeysRotateResponses, CartApiKeysRotateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/cart-api-keys/{kind}/rotate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List storefront products
 *
 * List active, cart-eligible products with browser-safe display data, active prices, and derived availability. Intended for publishable-key storefront and CMS-picker use; never returns product metadata or internal fields.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /storefront/products/{productId}` — Get a storefront product
 * - `GET /storefront/origins` — List storefront origins
 * - `POST /storefront/origins` — Register a storefront origin
 * - `DELETE /storefront/origins/{originId}` — Remove a storefront origin
 * - `GET /storefront/status` — Get storefront integration status
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const storefrontProductsList = <ThrowOnError extends boolean = false>(options?: Options<StorefrontProductsListData, ThrowOnError>) => (options?.client ?? client).get<StorefrontProductsListResponses, StorefrontProductsListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/storefront/products',
    ...options
});

/**
 * Get a storefront product
 *
 * Fetch one active, cart-eligible product by UUID, product reference, or slug. Same browser-safe projection as the list endpoint.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /storefront/products` — List storefront products
 * - `GET /storefront/origins` — List storefront origins
 * - `POST /storefront/origins` — Register a storefront origin
 * - `DELETE /storefront/origins/{originId}` — Remove a storefront origin
 * - `GET /storefront/status` — Get storefront integration status
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const storefrontProductsGet = <ThrowOnError extends boolean = false>(options: Options<StorefrontProductsGetData, ThrowOnError>) => (options.client ?? client).get<StorefrontProductsGetResponses, StorefrontProductsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/storefront/products/{productId}',
    ...options
});

/**
 * List storefront origins
 *
 * List the browser origins registered for publishable-key storefront calls.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /storefront/products` — List storefront products
 * - `GET /storefront/products/{productId}` — Get a storefront product
 * - `POST /storefront/origins` — Register a storefront origin
 * - `DELETE /storefront/origins/{originId}` — Remove a storefront origin
 * - `GET /storefront/status` — Get storefront integration status
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const storefrontOriginsList = <ThrowOnError extends boolean = false>(options?: Options<StorefrontOriginsListData, ThrowOnError>) => (options?.client ?? client).get<StorefrontOriginsListResponses, StorefrontOriginsListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/storefront/origins',
    ...options
});

/**
 * Register a storefront origin
 *
 * Register an exact web origin (scheme://host[:port]) for publishable-key storefront calls. Wildcards are rejected; http is allowed only for localhost.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /storefront/products` — List storefront products
 * - `GET /storefront/products/{productId}` — Get a storefront product
 * - `GET /storefront/origins` — List storefront origins
 * - `DELETE /storefront/origins/{originId}` — Remove a storefront origin
 * - `GET /storefront/status` — Get storefront integration status
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const storefrontOriginsCreate = <ThrowOnError extends boolean = false>(options?: Options<StorefrontOriginsCreateData, ThrowOnError>) => (options?.client ?? client).post<StorefrontOriginsCreateResponses, StorefrontOriginsCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/storefront/origins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Remove a storefront origin
 *
 * Remove a registered storefront origin. Browser calls from it fail closed afterwards.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /storefront/products` — List storefront products
 * - `GET /storefront/products/{productId}` — Get a storefront product
 * - `GET /storefront/origins` — List storefront origins
 * - `POST /storefront/origins` — Register a storefront origin
 * - `GET /storefront/status` — Get storefront integration status
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const storefrontOriginsDelete = <ThrowOnError extends boolean = false>(options: Options<StorefrontOriginsDeleteData, ThrowOnError>) => (options.client ?? client).delete<StorefrontOriginsDeleteResponses, StorefrontOriginsDeleteErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/storefront/origins/{originId}',
    ...options
});

/**
 * Get storefront integration status
 *
 * Readiness report for the Cart/headless-storefront setup: activation, managed keys, registered origins, product-read readiness, webhook health, and availability tracking. CART_DISABLED / KEYS_MISSING / ORIGIN_MISSING / PRODUCT_READ_UNAVAILABLE are fail-level; WEBHOOK_MISSING / WEBHOOK_UNREACHABLE are warn-level. Never returns key material.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /storefront/products` — List storefront products
 * - `GET /storefront/products/{productId}` — Get a storefront product
 * - `GET /storefront/origins` — List storefront origins
 * - `POST /storefront/origins` — Register a storefront origin
 * - `DELETE /storefront/origins/{originId}` — Remove a storefront origin
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 */
export const storefrontStatusGet = <ThrowOnError extends boolean = false>(options?: Options<StorefrontStatusGetData, ThrowOnError>) => (options?.client ?? client).get<StorefrontStatusGetResponses, StorefrontStatusGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/storefront/status',
    ...options
});

/**
 * List customers
 *
 * Retrieve a paginated list of customers for the merchant
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /customers/{customerId}/invoices` — List customer invoices
 * - `GET /customers/{customerId}/subscriptions` — List customer subscriptions
 * - `GET /customers/{customerId}/orders` — List customer orders
 * - `GET /customers/{customerId}/payments` — List customer payments
 * - `PUT /customers/external/batch` — Batch upsert customers by external ID
 * - `POST /customers` — Create a new customer
 * - `GET /customers/{id}` — Get customer by ID
 * - `PATCH /customers/{id}` — Update customer details
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const customersList = <ThrowOnError extends boolean = false>(options?: Options<CustomersListData, ThrowOnError>) => (options?.client ?? client).get<CustomersListResponses, CustomersListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customers',
    ...options
});

/**
 * Create a new customer
 *
 * Create a new customer record in the merchant's account
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /customers/{customerId}/invoices` — List customer invoices
 * - `GET /customers/{customerId}/subscriptions` — List customer subscriptions
 * - `GET /customers/{customerId}/orders` — List customer orders
 * - `GET /customers/{customerId}/payments` — List customer payments
 * - `PUT /customers/external/batch` — Batch upsert customers by external ID
 * - `GET /customers` — List customers
 * - `GET /customers/{id}` — Get customer by ID
 * - `PATCH /customers/{id}` — Update customer details
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const customersCreate = <ThrowOnError extends boolean = false>(options?: Options<CustomersCreateData, ThrowOnError>) => (options?.client ?? client).post<CustomersCreateResponses, CustomersCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get customer by ID
 *
 * Retrieve detailed information about a specific customer
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /customers/{customerId}/invoices` — List customer invoices
 * - `GET /customers/{customerId}/subscriptions` — List customer subscriptions
 * - `GET /customers/{customerId}/orders` — List customer orders
 * - `GET /customers/{customerId}/payments` — List customer payments
 * - `PUT /customers/external/batch` — Batch upsert customers by external ID
 * - `POST /customers` — Create a new customer
 * - `GET /customers` — List customers
 * - `PATCH /customers/{id}` — Update customer details
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const customersGet = <ThrowOnError extends boolean = false>(options: Options<CustomersGetData, ThrowOnError>) => (options.client ?? client).get<CustomersGetResponses, CustomersGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customers/{id}',
    ...options
});

/**
 * Update customer details
 *
 * Update an existing customer's information
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /customers/{customerId}/invoices` — List customer invoices
 * - `GET /customers/{customerId}/subscriptions` — List customer subscriptions
 * - `GET /customers/{customerId}/orders` — List customer orders
 * - `GET /customers/{customerId}/payments` — List customer payments
 * - `PUT /customers/external/batch` — Batch upsert customers by external ID
 * - `POST /customers` — Create a new customer
 * - `GET /customers` — List customers
 * - `GET /customers/{id}` — Get customer by ID
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const customersUpdate = <ThrowOnError extends boolean = false>(options: Options<CustomersUpdateData, ThrowOnError>) => (options.client ?? client).patch<CustomersUpdateResponses, CustomersUpdateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get customer payment rail availability
 *
 * Return per-rail availability for a customer, including mandate state and last successful rail usage.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /customers/{customerId}/invoices` — List customer invoices
 * - `GET /customers/{customerId}/subscriptions` — List customer subscriptions
 * - `GET /customers/{customerId}/orders` — List customer orders
 * - `GET /customers/{customerId}/payments` — List customer payments
 * - `PUT /customers/external/batch` — Batch upsert customers by external ID
 * - `POST /customers` — Create a new customer
 * - `GET /customers` — List customers
 * - `GET /customers/{id}` — Get customer by ID
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const customersPaymentRailsGet = <ThrowOnError extends boolean = false>(options: Options<CustomersPaymentRailsGetData, ThrowOnError>) => (options.client ?? client).get<CustomersPaymentRailsGetResponses, CustomersPaymentRailsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customers/{id}/payment-rails',
    ...options
});

/**
 * Get preferred payment rails
 *
 * Return smart-pick rail recommendations with customer history, mandate state, and margin-aware reasoning.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /customers/{customerId}/invoices` — List customer invoices
 * - `GET /customers/{customerId}/subscriptions` — List customer subscriptions
 * - `GET /customers/{customerId}/orders` — List customer orders
 * - `GET /customers/{customerId}/payments` — List customer payments
 * - `PUT /customers/external/batch` — Batch upsert customers by external ID
 * - `POST /customers` — Create a new customer
 * - `GET /customers` — List customers
 * - `GET /customers/{id}` — Get customer by ID
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const customersPreferredRailsGet = <ThrowOnError extends boolean = false>(options: Options<CustomersPreferredRailsGetData, ThrowOnError>) => (options.client ?? client).get<CustomersPreferredRailsGetResponses, CustomersPreferredRailsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customers/{id}/preferred-rails',
    ...options
});

/**
 * Get customer payment methods
 *
 * Retrieve all payment methods for a customer
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /customers/{customerId}/invoices` — List customer invoices
 * - `GET /customers/{customerId}/subscriptions` — List customer subscriptions
 * - `GET /customers/{customerId}/orders` — List customer orders
 * - `GET /customers/{customerId}/payments` — List customer payments
 * - `PUT /customers/external/batch` — Batch upsert customers by external ID
 * - `POST /customers` — Create a new customer
 * - `GET /customers` — List customers
 * - `GET /customers/{id}` — Get customer by ID
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const customersPaymentMethodsList = <ThrowOnError extends boolean = false>(options: Options<CustomersPaymentMethodsListData, ThrowOnError>) => (options.client ?? client).get<CustomersPaymentMethodsListResponses, CustomersPaymentMethodsListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customers/{id}/payment-methods',
    ...options
});

/**
 * List subscriptions
 *
 * Retrieve a paginated list of subscriptions with optional filters
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /subscriptions` — Create a new subscription
 * - `GET /subscriptions/{id}` — Get subscription by ID
 * - `PATCH /subscriptions/{id}` — Update subscription details
 * - `DELETE /subscriptions/{id}` — Delete subscription
 * - `POST /subscriptions/{id}/change-plan` — Change subscription plan
 * - `POST /subscriptions/{id}/change-quantity` — Change subscription quantity
 * - `POST /subscriptions/{id}/preview-renewal` — Preview subscription renewal
 * - `POST /subscriptions/{id}/pause` — Pause subscription
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const subscriptionsList = <ThrowOnError extends boolean = false>(options?: Options<SubscriptionsListData, ThrowOnError>) => (options?.client ?? client).get<SubscriptionsListResponses, SubscriptionsListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/subscriptions',
    ...options
});

/**
 * Create a new subscription
 *
 * Create a new subscription for a customer
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /subscriptions` — List subscriptions
 * - `GET /subscriptions/{id}` — Get subscription by ID
 * - `PATCH /subscriptions/{id}` — Update subscription details
 * - `DELETE /subscriptions/{id}` — Delete subscription
 * - `POST /subscriptions/{id}/change-plan` — Change subscription plan
 * - `POST /subscriptions/{id}/change-quantity` — Change subscription quantity
 * - `POST /subscriptions/{id}/preview-renewal` — Preview subscription renewal
 * - `POST /subscriptions/{id}/pause` — Pause subscription
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const subscriptionsCreate = <ThrowOnError extends boolean = false>(options?: Options<SubscriptionsCreateData, ThrowOnError>) => (options?.client ?? client).post<SubscriptionsCreateResponses, SubscriptionsCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/subscriptions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get subscription by ID
 *
 * Retrieve detailed information about a specific subscription
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /subscriptions` — Create a new subscription
 * - `GET /subscriptions` — List subscriptions
 * - `PATCH /subscriptions/{id}` — Update subscription details
 * - `DELETE /subscriptions/{id}` — Delete subscription
 * - `POST /subscriptions/{id}/change-plan` — Change subscription plan
 * - `POST /subscriptions/{id}/change-quantity` — Change subscription quantity
 * - `POST /subscriptions/{id}/preview-renewal` — Preview subscription renewal
 * - `POST /subscriptions/{id}/pause` — Pause subscription
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const subscriptionsGet = <ThrowOnError extends boolean = false>(options: Options<SubscriptionsGetData, ThrowOnError>) => (options.client ?? client).get<SubscriptionsGetResponses, SubscriptionsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/subscriptions/{id}',
    ...options
});

/**
 * Update subscription details
 *
 * Update an existing subscription's properties
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /subscriptions` — Create a new subscription
 * - `GET /subscriptions` — List subscriptions
 * - `GET /subscriptions/{id}` — Get subscription by ID
 * - `DELETE /subscriptions/{id}` — Delete subscription
 * - `POST /subscriptions/{id}/change-plan` — Change subscription plan
 * - `POST /subscriptions/{id}/change-quantity` — Change subscription quantity
 * - `POST /subscriptions/{id}/preview-renewal` — Preview subscription renewal
 * - `POST /subscriptions/{id}/pause` — Pause subscription
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const subscriptionsUpdate = <ThrowOnError extends boolean = false>(options: Options<SubscriptionsUpdateData, ThrowOnError>) => (options.client ?? client).patch<SubscriptionsUpdateResponses, SubscriptionsUpdateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/subscriptions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel subscription
 *
 * Cancel a subscription either immediately or at the end of the current billing period.
 *
 * **Modes:**
 * - `immediately`: Status set to "canceled", access revoked now
 * - `period_end`: cancelAtPeriodEnd flag set, access continues until period end
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /subscriptions` — Create a new subscription
 * - `GET /subscriptions` — List subscriptions
 * - `GET /subscriptions/{id}` — Get subscription by ID
 * - `PATCH /subscriptions/{id}` — Update subscription details
 * - `DELETE /subscriptions/{id}` — Delete subscription
 * - `POST /subscriptions/{id}/change-plan` — Change subscription plan
 * - `POST /subscriptions/{id}/change-quantity` — Change subscription quantity
 * - `POST /subscriptions/{id}/preview-renewal` — Preview subscription renewal
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const subscriptionsCancel = <ThrowOnError extends boolean = false>(options: Options<SubscriptionsCancelData, ThrowOnError>) => (options.client ?? client).post<SubscriptionsCancelResponses, SubscriptionsCancelErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/subscriptions/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * MRR Summary
 *
 * Get Monthly Recurring Revenue metrics and growth
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /analytics/revenue/time-series` — Revenue Time Series
 * - `GET /analytics/invoices/ar-aging` — A/R Aging Report
 * - `GET /analytics/collections/dso` — Days Sales Outstanding
 * - `GET /analytics/customers/ltv` — Customer LTV
 * - `GET /analytics/customers/{customerId}` — Customer Analytics
 * - `GET /analytics/payment-links/conversion` — Payment Link Conversion
 * - `GET /analytics/checkout/funnel` — Checkout Funnel Analytics
 * - `GET /analytics/checkout/abandonment/summary` — Abandonment Alert Summary
 */
export const analyticsRevenueMrrSummary = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsRevenueMrrSummaryData, ThrowOnError>) => (options?.client ?? client).get<AnalyticsRevenueMrrSummaryResponses, unknown, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/analytics/revenue/mrr-summary',
    ...options
});

/**
 * Revenue Time Series
 *
 * Get revenue data over time with configurable granularity
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /analytics/revenue/mrr-summary` — MRR Summary
 * - `GET /analytics/invoices/ar-aging` — A/R Aging Report
 * - `GET /analytics/collections/dso` — Days Sales Outstanding
 * - `GET /analytics/customers/ltv` — Customer LTV
 * - `GET /analytics/customers/{customerId}` — Customer Analytics
 * - `GET /analytics/payment-links/conversion` — Payment Link Conversion
 * - `GET /analytics/checkout/funnel` — Checkout Funnel Analytics
 * - `GET /analytics/checkout/abandonment/summary` — Abandonment Alert Summary
 */
export const analyticsRevenueTimeSeries = <ThrowOnError extends boolean = false>(options: Options<AnalyticsRevenueTimeSeriesData, ThrowOnError>) => (options.client ?? client).get<AnalyticsRevenueTimeSeriesResponses, unknown, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/analytics/revenue/time-series',
    ...options
});

/**
 * List refunds
 *
 * Retrieve a paginated list of refunds with optional filters. Results are ordered by creation date (newest first).
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /refunds` — Create a refund
 * - `GET /refunds/{id}` — Get refund by ID
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const refundsList = <ThrowOnError extends boolean = false>(options?: Options<RefundsListData, ThrowOnError>) => (options?.client ?? client).get<RefundsListResponses, RefundsListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/refunds',
    ...options
});

/**
 * Create a refund
 *
 * Initiate a refund for a payment. The refund will be processed through the original payment gateway.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /refunds` — List refunds
 * - `GET /refunds/{id}` — Get refund by ID
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const refundsCreate = <ThrowOnError extends boolean = false>(options?: Options<RefundsCreateData, ThrowOnError>) => (options?.client ?? client).post<RefundsCreateResponses, RefundsCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/refunds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get refund by ID
 *
 * Retrieve a single refund by its public ID (ref_xxx) or internal UUID.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /refunds` — List refunds
 * - `POST /refunds` — Create a refund
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const refundsGet = <ThrowOnError extends boolean = false>(options: Options<RefundsGetData, ThrowOnError>) => (options.client ?? client).get<RefundsGetResponses, RefundsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/refunds/{id}',
    ...options
});

/**
 * List credit notes
 *
 * Retrieve a paginated list of credit notes with optional filters. Results are ordered by creation date (newest first).
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /credit_notes` — Create a credit note
 * - `GET /credit_notes/{id}` — Get credit note by ID
 * - `POST /credit_notes/{id}/void` — Void a credit note
 * - `GET /credit_notes/invoice/{invoice_id}/eligibility` — Check credit note eligibility for an invoice
 * - `GET /credit_notes/transaction/{transaction_id}/reversal-eligibility` — Check reversal eligibility for a transaction
 * - `GET /credit_notes/{id}/lines` — List line items on a credit note
 * - `POST /credit_notes/preview` — Preview a credit note without creating it
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const creditNotesList = <ThrowOnError extends boolean = false>(options?: Options<CreditNotesListData, ThrowOnError>) => (options?.client ?? client).get<CreditNotesListResponses, CreditNotesListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/credit_notes',
    ...options
});

/**
 * Create a credit note
 *
 * Issue a credit note for a paid or partially paid invoice. The credit can be applied via refund to payment method, customer balance, or marked as external.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /credit_notes` — List credit notes
 * - `GET /credit_notes/{id}` — Get credit note by ID
 * - `POST /credit_notes/{id}/void` — Void a credit note
 * - `GET /credit_notes/invoice/{invoice_id}/eligibility` — Check credit note eligibility for an invoice
 * - `GET /credit_notes/transaction/{transaction_id}/reversal-eligibility` — Check reversal eligibility for a transaction
 * - `GET /credit_notes/{id}/lines` — List line items on a credit note
 * - `POST /credit_notes/preview` — Preview a credit note without creating it
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const creditNotesCreate = <ThrowOnError extends boolean = false>(options?: Options<CreditNotesCreateData, ThrowOnError>) => (options?.client ?? client).post<CreditNotesCreateResponses, CreditNotesCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/credit_notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get credit note by ID
 *
 * Retrieve a single credit note by its UUID.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /credit_notes` — List credit notes
 * - `POST /credit_notes` — Create a credit note
 * - `POST /credit_notes/{id}/void` — Void a credit note
 * - `GET /credit_notes/invoice/{invoice_id}/eligibility` — Check credit note eligibility for an invoice
 * - `GET /credit_notes/transaction/{transaction_id}/reversal-eligibility` — Check reversal eligibility for a transaction
 * - `GET /credit_notes/{id}/lines` — List line items on a credit note
 * - `POST /credit_notes/preview` — Preview a credit note without creating it
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const creditNotesGet = <ThrowOnError extends boolean = false>(options: Options<CreditNotesGetData, ThrowOnError>) => (options.client ?? client).get<CreditNotesGetResponses, CreditNotesGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/credit_notes/{id}',
    ...options
});

/**
 * Void a credit note
 *
 * Void a credit note that has been issued but not yet fully applied. This is an accounting void — it reverses the credit without creating a new financial transaction.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /credit_notes` — List credit notes
 * - `POST /credit_notes` — Create a credit note
 * - `GET /credit_notes/{id}` — Get credit note by ID
 * - `GET /credit_notes/invoice/{invoice_id}/eligibility` — Check credit note eligibility for an invoice
 * - `GET /credit_notes/transaction/{transaction_id}/reversal-eligibility` — Check reversal eligibility for a transaction
 * - `GET /credit_notes/{id}/lines` — List line items on a credit note
 * - `POST /credit_notes/preview` — Preview a credit note without creating it
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const creditNotesVoid = <ThrowOnError extends boolean = false>(options: Options<CreditNotesVoidData, ThrowOnError>) => (options.client ?? client).post<CreditNotesVoidResponses, CreditNotesVoidErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/credit_notes/{id}/void',
    ...options
});

/**
 * List line items on a credit note
 *
 * Returns the line items attached to a credit note. Each line describes a portion of the invoice that the credit applies to — either a whole invoice line or a prorated slice. Use this to reconstruct the credit's effect per invoice line (for example, when displaying the credit breakdown in your own UI).
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /credit_notes` — List credit notes
 * - `POST /credit_notes` — Create a credit note
 * - `GET /credit_notes/{id}` — Get credit note by ID
 * - `POST /credit_notes/{id}/void` — Void a credit note
 * - `GET /credit_notes/invoice/{invoice_id}/eligibility` — Check credit note eligibility for an invoice
 * - `GET /credit_notes/transaction/{transaction_id}/reversal-eligibility` — Check reversal eligibility for a transaction
 * - `POST /credit_notes/preview` — Preview a credit note without creating it
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const creditNotesListLines = <ThrowOnError extends boolean = false>(options: Options<CreditNotesListLinesData, ThrowOnError>) => (options.client ?? client).get<CreditNotesListLinesResponses, CreditNotesListLinesErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/credit_notes/{id}/lines',
    ...options
});

/**
 * Preview a credit note without creating it
 *
 * Compute what a credit note would look like against a specific invoice without persisting anything. Use this to validate amounts and show a "here's what will happen" UI before the merchant commits. No side effects — no DB writes, no events emitted, no refunds initiated. Mirrors Stripe's `POST /v1/credit_notes/preview`.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /credit_notes` — List credit notes
 * - `POST /credit_notes` — Create a credit note
 * - `GET /credit_notes/{id}` — Get credit note by ID
 * - `POST /credit_notes/{id}/void` — Void a credit note
 * - `GET /credit_notes/invoice/{invoice_id}/eligibility` — Check credit note eligibility for an invoice
 * - `GET /credit_notes/transaction/{transaction_id}/reversal-eligibility` — Check reversal eligibility for a transaction
 * - `GET /credit_notes/{id}/lines` — List line items on a credit note
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const creditNotesPreview = <ThrowOnError extends boolean = false>(options: Options<CreditNotesPreviewData, ThrowOnError>) => (options.client ?? client).post<CreditNotesPreviewResponses, CreditNotesPreviewErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/credit_notes/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List payment links
 *
 * List payment links for the authenticated merchant with pagination and filters
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /payment-links` — Create a new payment link
 * - `GET /payment-links/{id}` — Get payment link by ID
 * - `POST /payment-links/{id}/expire` — Expire a payment link (deprecated)
 * - `PATCH /payment-links/{id}/status` — Update payment link status
 * - `POST /payment-links/{id}/deactivate` — Deactivate a payment link (deprecated)
 * - `POST /payment-links/{id}/activate` — Activate a payment link (deprecated)
 * - `POST /payment-links/{id}/archive` — Archive a payment link (deprecated)
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const paymentLinksList = <ThrowOnError extends boolean = false>(options?: Options<PaymentLinksListData, ThrowOnError>) => (options?.client ?? client).get<PaymentLinksListResponses, PaymentLinksListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-links',
    ...options
});

/**
 * Create a new payment link
 *
 * Create a new payment link for invoices, subscriptions, or custom amounts
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /payment-links` — List payment links
 * - `GET /payment-links/{id}` — Get payment link by ID
 * - `POST /payment-links/{id}/expire` — Expire a payment link (deprecated)
 * - `PATCH /payment-links/{id}/status` — Update payment link status
 * - `POST /payment-links/{id}/deactivate` — Deactivate a payment link (deprecated)
 * - `POST /payment-links/{id}/activate` — Activate a payment link (deprecated)
 * - `POST /payment-links/{id}/archive` — Archive a payment link (deprecated)
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const paymentLinksCreate = <ThrowOnError extends boolean = false>(options?: Options<PaymentLinksCreateData, ThrowOnError>) => (options?.client ?? client).post<PaymentLinksCreateResponses, PaymentLinksCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get payment link by ID
 *
 * Retrieve a payment link by its UUID or public_id
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /payment-links` — Create a new payment link
 * - `GET /payment-links` — List payment links
 * - `POST /payment-links/{id}/expire` — Expire a payment link (deprecated)
 * - `PATCH /payment-links/{id}/status` — Update payment link status
 * - `POST /payment-links/{id}/deactivate` — Deactivate a payment link (deprecated)
 * - `POST /payment-links/{id}/activate` — Activate a payment link (deprecated)
 * - `POST /payment-links/{id}/archive` — Archive a payment link (deprecated)
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const paymentLinksGet = <ThrowOnError extends boolean = false>(options: Options<PaymentLinksGetData, ThrowOnError>) => (options.client ?? client).get<PaymentLinksGetResponses, PaymentLinksGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-links/{id}',
    ...options
});

/**
 * Expire a payment link (deprecated)
 *
 * **Deprecated — use `PATCH /v2/payment-links/{id}/status` with `status: "expired"` instead.** This convenience endpoint will be removed in a future API version. Mark a payment link as expired, preventing further use.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /payment-links` — Create a new payment link
 * - `GET /payment-links` — List payment links
 * - `GET /payment-links/{id}` — Get payment link by ID
 * - `PATCH /payment-links/{id}/status` — Update payment link status
 * - `POST /payment-links/{id}/deactivate` — Deactivate a payment link (deprecated)
 * - `POST /payment-links/{id}/activate` — Activate a payment link (deprecated)
 * - `POST /payment-links/{id}/archive` — Archive a payment link (deprecated)
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 *
 * @deprecated
 */
export const paymentLinksExpire = <ThrowOnError extends boolean = false>(options: Options<PaymentLinksExpireData, ThrowOnError>) => (options.client ?? client).post<PaymentLinksExpireResponses, PaymentLinksExpireErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-links/{id}/expire',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update payment link status
 *
 * Change the status of a payment link. Active links accept payments, inactive links are temporarily disabled, and archived links are permanently disabled and cannot be reactivated.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /payment-links` — Create a new payment link
 * - `GET /payment-links` — List payment links
 * - `GET /payment-links/{id}` — Get payment link by ID
 * - `POST /payment-links/{id}/expire` — Expire a payment link (deprecated)
 * - `POST /payment-links/{id}/deactivate` — Deactivate a payment link (deprecated)
 * - `POST /payment-links/{id}/activate` — Activate a payment link (deprecated)
 * - `POST /payment-links/{id}/archive` — Archive a payment link (deprecated)
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const paymentLinksUpdate = <ThrowOnError extends boolean = false>(options: Options<PaymentLinksUpdateData, ThrowOnError>) => (options.client ?? client).patch<PaymentLinksUpdateResponses, PaymentLinksUpdateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-links/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate a payment link (deprecated)
 *
 * **Deprecated — use `PATCH /v2/payment-links/{id}/status` with `status: "inactive"` instead.** This convenience endpoint will be removed in a future API version. Temporarily disable a payment link. It can be reactivated later.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /payment-links` — Create a new payment link
 * - `GET /payment-links` — List payment links
 * - `GET /payment-links/{id}` — Get payment link by ID
 * - `POST /payment-links/{id}/expire` — Expire a payment link (deprecated)
 * - `PATCH /payment-links/{id}/status` — Update payment link status
 * - `POST /payment-links/{id}/activate` — Activate a payment link (deprecated)
 * - `POST /payment-links/{id}/archive` — Archive a payment link (deprecated)
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 *
 * @deprecated
 */
export const paymentLinksDeactivate = <ThrowOnError extends boolean = false>(options: Options<PaymentLinksDeactivateData, ThrowOnError>) => (options.client ?? client).post<PaymentLinksDeactivateResponses, PaymentLinksDeactivateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-links/{id}/deactivate',
    ...options
});

/**
 * Activate a payment link (deprecated)
 *
 * **Deprecated — use `PATCH /v2/payment-links/{id}/status` with `status: "active"` instead.** This convenience endpoint will be removed in a future API version. Enable a payment link to accept payments. Cannot be used on archived links.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /payment-links` — Create a new payment link
 * - `GET /payment-links` — List payment links
 * - `GET /payment-links/{id}` — Get payment link by ID
 * - `POST /payment-links/{id}/expire` — Expire a payment link (deprecated)
 * - `PATCH /payment-links/{id}/status` — Update payment link status
 * - `POST /payment-links/{id}/deactivate` — Deactivate a payment link (deprecated)
 * - `POST /payment-links/{id}/archive` — Archive a payment link (deprecated)
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 *
 * @deprecated
 */
export const paymentLinksActivate = <ThrowOnError extends boolean = false>(options: Options<PaymentLinksActivateData, ThrowOnError>) => (options.client ?? client).post<PaymentLinksActivateResponses, PaymentLinksActivateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-links/{id}/activate',
    ...options
});

/**
 * Archive a payment link (deprecated)
 *
 * **Deprecated — use `PATCH /v2/payment-links/{id}/status` with `status: "archived"` instead.** This convenience endpoint will be removed in a future API version. Permanently disable a payment link. This action cannot be undone.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /payment-links` — Create a new payment link
 * - `GET /payment-links` — List payment links
 * - `GET /payment-links/{id}` — Get payment link by ID
 * - `POST /payment-links/{id}/expire` — Expire a payment link (deprecated)
 * - `PATCH /payment-links/{id}/status` — Update payment link status
 * - `POST /payment-links/{id}/deactivate` — Deactivate a payment link (deprecated)
 * - `POST /payment-links/{id}/activate` — Activate a payment link (deprecated)
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 *
 * @deprecated
 */
export const paymentLinksArchive = <ThrowOnError extends boolean = false>(options: Options<PaymentLinksArchiveData, ThrowOnError>) => (options.client ?? client).post<PaymentLinksArchiveResponses, PaymentLinksArchiveErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-links/{id}/archive',
    ...options
});

/**
 * List prices
 *
 * List all prices for the authenticated merchant. Supports filtering and cursor-based pagination.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /prices` — Create a price
 * - `GET /prices/{id}` — Retrieve a price
 * - `PATCH /prices/{id}` — Update a price
 * - `DELETE /prices/{id}` — Archive a price
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const pricesList = <ThrowOnError extends boolean = false>(options?: Options<PricesListData, ThrowOnError>) => (options?.client ?? client).get<PricesListResponses, PricesListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/prices',
    ...options
});

/**
 * Create a price
 *
 * Creates a new price for a product. Supports fixed, pay-what-you-want, and free pricing models.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /prices` — List prices
 * - `GET /prices/{id}` — Retrieve a price
 * - `PATCH /prices/{id}` — Update a price
 * - `DELETE /prices/{id}` — Archive a price
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const pricesCreate = <ThrowOnError extends boolean = false>(options: Options<PricesCreateData, ThrowOnError>) => (options.client ?? client).post<PricesCreateResponses, PricesCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/prices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive a price
 *
 * Archives a price by setting active to false. The price remains in the system but cannot be used for new purchases.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /prices` — List prices
 * - `POST /prices` — Create a price
 * - `GET /prices/{id}` — Retrieve a price
 * - `PATCH /prices/{id}` — Update a price
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const pricesArchive = <ThrowOnError extends boolean = false>(options: Options<PricesArchiveData, ThrowOnError>) => (options.client ?? client).delete<PricesArchiveResponses, PricesArchiveErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/prices/{id}',
    ...options
});

/**
 * Retrieve a price
 *
 * Retrieves a price by its ID.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /prices` — List prices
 * - `POST /prices` — Create a price
 * - `PATCH /prices/{id}` — Update a price
 * - `DELETE /prices/{id}` — Archive a price
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const pricesGet = <ThrowOnError extends boolean = false>(options: Options<PricesGetData, ThrowOnError>) => (options.client ?? client).get<PricesGetResponses, PricesGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/prices/{id}',
    ...options
});

/**
 * Update a price
 *
 * Updates a price. Only certain fields can be updated (active, name, nickname, lookup_key, metadata). Core pricing fields are immutable.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /prices` — List prices
 * - `POST /prices` — Create a price
 * - `GET /prices/{id}` — Retrieve a price
 * - `DELETE /prices/{id}` — Archive a price
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const pricesUpdate = <ThrowOnError extends boolean = false>(options: Options<PricesUpdateData, ThrowOnError>) => (options.client ?? client).patch<PricesUpdateResponses, PricesUpdateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/prices/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an accounting-led invoice payment request
 *
 * Claims or reuses an ExternalAccountingInvoicePaymentRequest and mints a provider-neutral checkout session. Does not create a RevKeen invoice. Requires Idempotency-Key.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /integrations/accounting/invoice-payment-requests/{id}` — Get an accounting-led invoice payment request
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const accountingInvoicePaymentRequestsCreate = <ThrowOnError extends boolean = false>(options?: Options<AccountingInvoicePaymentRequestsCreateData, ThrowOnError>) => (options?.client ?? client).post<AccountingInvoicePaymentRequestsCreateResponses, AccountingInvoicePaymentRequestsCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/integrations/accounting/invoice-payment-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get an accounting-led invoice payment request
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /integrations/accounting/invoice-payment-requests` — Create an accounting-led invoice payment request
 *
 * **Common errors**
 *
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const accountingInvoicePaymentRequestsGet = <ThrowOnError extends boolean = false>(options: Options<AccountingInvoicePaymentRequestsGetData, ThrowOnError>) => (options.client ?? client).get<AccountingInvoicePaymentRequestsGetResponses, AccountingInvoicePaymentRequestsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/integrations/accounting/invoice-payment-requests/{id}',
    ...options
});

/**
 * List webhook endpoints
 *
 * List all webhook endpoints for the authenticated merchant. Supports filtering by status and pagination.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /webhook-endpoints` — Create webhook endpoint
 * - `GET /webhook-endpoints/{id}` — Get webhook endpoint
 * - `PATCH /webhook-endpoints/{id}` — Update webhook endpoint
 * - `DELETE /webhook-endpoints/{id}` — Delete webhook endpoint
 * - `POST /webhook-endpoints/{id}/rotate-secret` — Rotate signing secret
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const webhookEndpointsList = <ThrowOnError extends boolean = false>(options?: Options<WebhookEndpointsListData, ThrowOnError>) => (options?.client ?? client).get<WebhookEndpointsListResponses, WebhookEndpointsListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/webhook-endpoints',
    ...options
});

/**
 * Create webhook endpoint
 *
 * Create a webhook endpoint to receive event notifications at the given URL. Returns the endpoint with its signing secret — store the secret securely, it is only shown once.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /webhook-endpoints` — List webhook endpoints
 * - `GET /webhook-endpoints/{id}` — Get webhook endpoint
 * - `PATCH /webhook-endpoints/{id}` — Update webhook endpoint
 * - `DELETE /webhook-endpoints/{id}` — Delete webhook endpoint
 * - `POST /webhook-endpoints/{id}/rotate-secret` — Rotate signing secret
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const webhookEndpointsCreate = <ThrowOnError extends boolean = false>(options?: Options<WebhookEndpointsCreateData, ThrowOnError>) => (options?.client ?? client).post<WebhookEndpointsCreateResponses, WebhookEndpointsCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/webhook-endpoints',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete webhook endpoint
 *
 * Permanently delete a webhook endpoint and all its event subscriptions.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /webhook-endpoints` — List webhook endpoints
 * - `POST /webhook-endpoints` — Create webhook endpoint
 * - `GET /webhook-endpoints/{id}` — Get webhook endpoint
 * - `PATCH /webhook-endpoints/{id}` — Update webhook endpoint
 * - `POST /webhook-endpoints/{id}/rotate-secret` — Rotate signing secret
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const webhookEndpointsDelete = <ThrowOnError extends boolean = false>(options: Options<WebhookEndpointsDeleteData, ThrowOnError>) => (options.client ?? client).delete<WebhookEndpointsDeleteResponses, WebhookEndpointsDeleteErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/webhook-endpoints/{id}',
    ...options
});

/**
 * Get webhook endpoint
 *
 * Retrieve a single webhook endpoint by ID, including delivery statistics.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /webhook-endpoints` — List webhook endpoints
 * - `POST /webhook-endpoints` — Create webhook endpoint
 * - `PATCH /webhook-endpoints/{id}` — Update webhook endpoint
 * - `DELETE /webhook-endpoints/{id}` — Delete webhook endpoint
 * - `POST /webhook-endpoints/{id}/rotate-secret` — Rotate signing secret
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const webhookEndpointsGet = <ThrowOnError extends boolean = false>(options: Options<WebhookEndpointsGetData, ThrowOnError>) => (options.client ?? client).get<WebhookEndpointsGetResponses, WebhookEndpointsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/webhook-endpoints/{id}',
    ...options
});

/**
 * Update webhook endpoint
 *
 * Update a webhook endpoint's URL, subscribed events, description, or enabled status.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /webhook-endpoints` — List webhook endpoints
 * - `POST /webhook-endpoints` — Create webhook endpoint
 * - `GET /webhook-endpoints/{id}` — Get webhook endpoint
 * - `DELETE /webhook-endpoints/{id}` — Delete webhook endpoint
 * - `POST /webhook-endpoints/{id}/rotate-secret` — Rotate signing secret
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const webhookEndpointsUpdate = <ThrowOnError extends boolean = false>(options: Options<WebhookEndpointsUpdateData, ThrowOnError>) => (options.client ?? client).patch<WebhookEndpointsUpdateResponses, WebhookEndpointsUpdateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/webhook-endpoints/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate signing secret
 *
 * Generate a new signing secret for a webhook endpoint. The old secret is immediately invalidated. Store the new secret securely — it is only returned in this response.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /webhook-endpoints` — List webhook endpoints
 * - `POST /webhook-endpoints` — Create webhook endpoint
 * - `GET /webhook-endpoints/{id}` — Get webhook endpoint
 * - `PATCH /webhook-endpoints/{id}` — Update webhook endpoint
 * - `DELETE /webhook-endpoints/{id}` — Delete webhook endpoint
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const webhookEndpointsRotateSecret = <ThrowOnError extends boolean = false>(options: Options<WebhookEndpointsRotateSecretData, ThrowOnError>) => (options.client ?? client).post<WebhookEndpointsRotateSecretResponses, WebhookEndpointsRotateSecretErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/webhook-endpoints/{id}/rotate-secret',
    ...options
});

/**
 * List webhook deliveries
 *
 * List individual webhook delivery attempts across all endpoints for the authenticated merchant. Use filters to scope to a specific endpoint, a specific event, or a specific delivery status. Results are returned in reverse chronological order.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /webhook-deliveries/{id}` — Retrieve a webhook delivery
 * - `POST /webhook-deliveries/{id}/retry` — Retry a webhook delivery
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const webhookDeliveriesList = <ThrowOnError extends boolean = false>(options?: Options<WebhookDeliveriesListData, ThrowOnError>) => (options?.client ?? client).get<WebhookDeliveriesListResponses, WebhookDeliveriesListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/webhook-deliveries',
    ...options
});

/**
 * Retrieve a webhook delivery
 *
 * Retrieve the details of a single webhook delivery including its last attempt outcome.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /webhook-deliveries` — List webhook deliveries
 * - `POST /webhook-deliveries/{id}/retry` — Retry a webhook delivery
 *
 * **Common errors**
 *
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const webhookDeliveriesGet = <ThrowOnError extends boolean = false>(options: Options<WebhookDeliveriesGetData, ThrowOnError>) => (options.client ?? client).get<WebhookDeliveriesGetResponses, WebhookDeliveriesGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/webhook-deliveries/{id}',
    ...options
});

/**
 * Retry a webhook delivery
 *
 * Queue an immediate retry of this delivery. The delivery is marked `pending` and `next_retry_at` is set to now; the dispatcher picks it up on its next tick. Calling retry on an already-pending delivery just advances its retry time. Dead-lettered deliveries can be retried once; succeeded deliveries cannot.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /webhook-deliveries` — List webhook deliveries
 * - `GET /webhook-deliveries/{id}` — Retrieve a webhook delivery
 *
 * **Common errors**
 *
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const webhookDeliveriesRetry = <ThrowOnError extends boolean = false>(options: Options<WebhookDeliveriesRetryData, ThrowOnError>) => (options.client ?? client).post<WebhookDeliveriesRetryResponses, WebhookDeliveriesRetryErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/webhook-deliveries/{id}/retry',
    ...options
});

/**
 * Create a customer-portal session
 *
 * Mint a short-lived bearer token that authenticates a specific customer against /v2/customer-portal*. Returns an opaque `rkcps_...` token that expires in 60 minutes by default. Call this server-side from the merchant's backend, then hand the token to the customer's browser or embedded client. Treat the token like a password — never log it and never expose it to untrusted code.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /customer-portal/customer` — Retrieve the authenticated customer
 * - `GET /customer-portal/subscriptions` — List the authenticated customer's subscriptions
 * - `GET /customer-portal/subscriptions/{id}` — Retrieve a subscription
 * - `POST /customer-portal/subscriptions/{id}/cancel` — Cancel a subscription
 * - `GET /customer-portal/invoices` — List the authenticated customer's invoices
 * - `GET /customer-portal/invoices/{id}` — Retrieve an invoice
 * - `GET /customer-portal/mandates` — List the authenticated customer's Direct Debit mandates
 * - `POST /customer-portal/mandates/{id}/re-authorize` — Re-authorise a Direct Debit mandate with new bank details
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const customerPortalSessionsCreate = <ThrowOnError extends boolean = false>(options: Options<CustomerPortalSessionsCreateData, ThrowOnError>) => (options.client ?? client).post<CustomerPortalSessionsCreateResponses, CustomerPortalSessionsCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-portal/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve the authenticated customer
 *
 * Returns the customer represented by the bearer token. Useful as a warm-up / identity check when an embedded portal page loads.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /customer-portal/sessions` — Create a customer-portal session
 * - `GET /customer-portal/subscriptions` — List the authenticated customer's subscriptions
 * - `GET /customer-portal/subscriptions/{id}` — Retrieve a subscription
 * - `POST /customer-portal/subscriptions/{id}/cancel` — Cancel a subscription
 * - `GET /customer-portal/invoices` — List the authenticated customer's invoices
 * - `GET /customer-portal/invoices/{id}` — Retrieve an invoice
 * - `GET /customer-portal/mandates` — List the authenticated customer's Direct Debit mandates
 * - `POST /customer-portal/mandates/{id}/re-authorize` — Re-authorise a Direct Debit mandate with new bank details
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const customerPortalCustomerGet = <ThrowOnError extends boolean = false>(options?: Options<CustomerPortalCustomerGetData, ThrowOnError>) => (options?.client ?? client).get<CustomerPortalCustomerGetResponses, CustomerPortalCustomerGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-portal/customer',
    ...options
});

/**
 * List the authenticated customer's subscriptions
 *
 * Returns subscriptions where the customer is the subscriber. Results are reverse-chronological by creation time and paginate via `starting_after` / `ending_before` cursors.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /customer-portal/sessions` — Create a customer-portal session
 * - `GET /customer-portal/customer` — Retrieve the authenticated customer
 * - `GET /customer-portal/subscriptions/{id}` — Retrieve a subscription
 * - `POST /customer-portal/subscriptions/{id}/cancel` — Cancel a subscription
 * - `GET /customer-portal/invoices` — List the authenticated customer's invoices
 * - `GET /customer-portal/invoices/{id}` — Retrieve an invoice
 * - `GET /customer-portal/mandates` — List the authenticated customer's Direct Debit mandates
 * - `POST /customer-portal/mandates/{id}/re-authorize` — Re-authorise a Direct Debit mandate with new bank details
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const customerPortalSubscriptionsList = <ThrowOnError extends boolean = false>(options?: Options<CustomerPortalSubscriptionsListData, ThrowOnError>) => (options?.client ?? client).get<CustomerPortalSubscriptionsListResponses, CustomerPortalSubscriptionsListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-portal/subscriptions',
    ...options
});

/**
 * Retrieve a subscription
 *
 * Returns a subscription owned by the authenticated customer. 404s on cross-customer access even if the subscription exists.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /customer-portal/sessions` — Create a customer-portal session
 * - `GET /customer-portal/customer` — Retrieve the authenticated customer
 * - `GET /customer-portal/subscriptions` — List the authenticated customer's subscriptions
 * - `POST /customer-portal/subscriptions/{id}/cancel` — Cancel a subscription
 * - `GET /customer-portal/invoices` — List the authenticated customer's invoices
 * - `GET /customer-portal/invoices/{id}` — Retrieve an invoice
 * - `GET /customer-portal/mandates` — List the authenticated customer's Direct Debit mandates
 * - `POST /customer-portal/mandates/{id}/re-authorize` — Re-authorise a Direct Debit mandate with new bank details
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const customerPortalSubscriptionsGet = <ThrowOnError extends boolean = false>(options: Options<CustomerPortalSubscriptionsGetData, ThrowOnError>) => (options.client ?? client).get<CustomerPortalSubscriptionsGetResponses, CustomerPortalSubscriptionsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-portal/subscriptions/{id}',
    ...options
});

/**
 * Cancel a subscription
 *
 * Cancel a subscription owned by the authenticated customer. By default the subscription is scheduled to cancel at the end of the current billing period — set `cancel_at_period_end=false` to cancel immediately. Idempotent — cancelling an already-canceled subscription is a no-op that returns the current state.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /customer-portal/sessions` — Create a customer-portal session
 * - `GET /customer-portal/customer` — Retrieve the authenticated customer
 * - `GET /customer-portal/subscriptions` — List the authenticated customer's subscriptions
 * - `GET /customer-portal/subscriptions/{id}` — Retrieve a subscription
 * - `GET /customer-portal/invoices` — List the authenticated customer's invoices
 * - `GET /customer-portal/invoices/{id}` — Retrieve an invoice
 * - `GET /customer-portal/mandates` — List the authenticated customer's Direct Debit mandates
 * - `POST /customer-portal/mandates/{id}/re-authorize` — Re-authorise a Direct Debit mandate with new bank details
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const customerPortalSubscriptionsCancel = <ThrowOnError extends boolean = false>(options: Options<CustomerPortalSubscriptionsCancelData, ThrowOnError>) => (options.client ?? client).post<CustomerPortalSubscriptionsCancelResponses, CustomerPortalSubscriptionsCancelErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-portal/subscriptions/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the authenticated customer's invoices
 *
 * Returns invoices owned by the authenticated customer, reverse-chronological by `invoice_date`. Use the same `starting_after`/`ending_before` cursor pattern as subscriptions.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /customer-portal/sessions` — Create a customer-portal session
 * - `GET /customer-portal/customer` — Retrieve the authenticated customer
 * - `GET /customer-portal/subscriptions` — List the authenticated customer's subscriptions
 * - `GET /customer-portal/subscriptions/{id}` — Retrieve a subscription
 * - `POST /customer-portal/subscriptions/{id}/cancel` — Cancel a subscription
 * - `GET /customer-portal/invoices/{id}` — Retrieve an invoice
 * - `GET /customer-portal/mandates` — List the authenticated customer's Direct Debit mandates
 * - `POST /customer-portal/mandates/{id}/re-authorize` — Re-authorise a Direct Debit mandate with new bank details
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const customerPortalInvoicesList = <ThrowOnError extends boolean = false>(options?: Options<CustomerPortalInvoicesListData, ThrowOnError>) => (options?.client ?? client).get<CustomerPortalInvoicesListResponses, CustomerPortalInvoicesListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-portal/invoices',
    ...options
});

/**
 * Retrieve an invoice
 *
 * Returns an invoice owned by the authenticated customer.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /customer-portal/sessions` — Create a customer-portal session
 * - `GET /customer-portal/customer` — Retrieve the authenticated customer
 * - `GET /customer-portal/subscriptions` — List the authenticated customer's subscriptions
 * - `GET /customer-portal/subscriptions/{id}` — Retrieve a subscription
 * - `POST /customer-portal/subscriptions/{id}/cancel` — Cancel a subscription
 * - `GET /customer-portal/invoices` — List the authenticated customer's invoices
 * - `GET /customer-portal/mandates` — List the authenticated customer's Direct Debit mandates
 * - `POST /customer-portal/mandates/{id}/re-authorize` — Re-authorise a Direct Debit mandate with new bank details
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const customerPortalInvoicesGet = <ThrowOnError extends boolean = false>(options: Options<CustomerPortalInvoicesGetData, ThrowOnError>) => (options.client ?? client).get<CustomerPortalInvoicesGetResponses, CustomerPortalInvoicesGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-portal/invoices/{id}',
    ...options
});

/**
 * List the authenticated customer's Direct Debit mandates
 *
 * Returns the customer's Direct Debit mandates (status, masked account, next collection date). Requires the merchant to have portal DD self-service enabled.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /customer-portal/sessions` — Create a customer-portal session
 * - `GET /customer-portal/customer` — Retrieve the authenticated customer
 * - `GET /customer-portal/subscriptions` — List the authenticated customer's subscriptions
 * - `GET /customer-portal/subscriptions/{id}` — Retrieve a subscription
 * - `POST /customer-portal/subscriptions/{id}/cancel` — Cancel a subscription
 * - `GET /customer-portal/invoices` — List the authenticated customer's invoices
 * - `GET /customer-portal/invoices/{id}` — Retrieve an invoice
 * - `POST /customer-portal/mandates/{id}/re-authorize` — Re-authorise a Direct Debit mandate with new bank details
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const customerPortalMandatesList = <ThrowOnError extends boolean = false>(options?: Options<CustomerPortalMandatesListData, ThrowOnError>) => (options?.client ?? client).get<CustomerPortalMandatesListResponses, CustomerPortalMandatesListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-portal/mandates',
    ...options
});

/**
 * Re-authorise a Direct Debit mandate with new bank details
 *
 * Updates the existing provider customer with new bank details and returns the mandate to pending while the fresh Bacs instruction is lodged. Requires portal DD self-service.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /customer-portal/sessions` — Create a customer-portal session
 * - `GET /customer-portal/customer` — Retrieve the authenticated customer
 * - `GET /customer-portal/subscriptions` — List the authenticated customer's subscriptions
 * - `GET /customer-portal/subscriptions/{id}` — Retrieve a subscription
 * - `POST /customer-portal/subscriptions/{id}/cancel` — Cancel a subscription
 * - `GET /customer-portal/invoices` — List the authenticated customer's invoices
 * - `GET /customer-portal/invoices/{id}` — Retrieve an invoice
 * - `GET /customer-portal/mandates` — List the authenticated customer's Direct Debit mandates
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 * - `422 unprocessable_entity` — business-rule failure (for example, refunding more than the original charge).
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const customerPortalMandatesReauthorize = <ThrowOnError extends boolean = false>(options: Options<CustomerPortalMandatesReauthorizeData, ThrowOnError>) => (options.client ?? client).post<CustomerPortalMandatesReauthorizeResponses, CustomerPortalMandatesReauthorizeErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-portal/mandates/{id}/re-authorize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel a Direct Debit mandate
 *
 * Cancels the mandate for future collections only. Requires portal DD self-service. Bank changes affect future only (per approved V13 mockup).
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /customer-portal/sessions` — Create a customer-portal session
 * - `GET /customer-portal/customer` — Retrieve the authenticated customer
 * - `GET /customer-portal/subscriptions` — List the authenticated customer's subscriptions
 * - `GET /customer-portal/subscriptions/{id}` — Retrieve a subscription
 * - `POST /customer-portal/subscriptions/{id}/cancel` — Cancel a subscription
 * - `GET /customer-portal/invoices` — List the authenticated customer's invoices
 * - `GET /customer-portal/invoices/{id}` — Retrieve an invoice
 * - `GET /customer-portal/mandates` — List the authenticated customer's Direct Debit mandates
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const customerPortalMandatesCancel = <ThrowOnError extends boolean = false>(options: Options<CustomerPortalMandatesCancelData, ThrowOnError>) => (options.client ?? client).post<CustomerPortalMandatesCancelResponses, CustomerPortalMandatesCancelErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-portal/mandates/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a step-up OTP for a Direct Debit bank-detail change
 *
 * Emails the customer a one-time code that must be verified (verify-otp) before a change-of-bank can be submitted.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /customer-portal/sessions` — Create a customer-portal session
 * - `GET /customer-portal/customer` — Retrieve the authenticated customer
 * - `GET /customer-portal/subscriptions` — List the authenticated customer's subscriptions
 * - `GET /customer-portal/subscriptions/{id}` — Retrieve a subscription
 * - `POST /customer-portal/subscriptions/{id}/cancel` — Cancel a subscription
 * - `GET /customer-portal/invoices` — List the authenticated customer's invoices
 * - `GET /customer-portal/invoices/{id}` — Retrieve an invoice
 * - `GET /customer-portal/mandates` — List the authenticated customer's Direct Debit mandates
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 * - `422 unprocessable_entity` — business-rule failure (for example, refunding more than the original charge).
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const customerPortalMandatesReauthorizeSendOtp = <ThrowOnError extends boolean = false>(options: Options<CustomerPortalMandatesReauthorizeSendOtpData, ThrowOnError>) => (options.client ?? client).post<CustomerPortalMandatesReauthorizeSendOtpResponses, CustomerPortalMandatesReauthorizeSendOtpErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-portal/mandates/{id}/re-authorize/send-otp',
    ...options
});

/**
 * Verify a step-up OTP and receive a change-of-bank token
 *
 * Verifies the one-time code and returns a short-lived verification_token bound to this customer, the change-bank action, and this mandate. Pass it to re-authorize.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /customer-portal/sessions` — Create a customer-portal session
 * - `GET /customer-portal/customer` — Retrieve the authenticated customer
 * - `GET /customer-portal/subscriptions` — List the authenticated customer's subscriptions
 * - `GET /customer-portal/subscriptions/{id}` — Retrieve a subscription
 * - `POST /customer-portal/subscriptions/{id}/cancel` — Cancel a subscription
 * - `GET /customer-portal/invoices` — List the authenticated customer's invoices
 * - `GET /customer-portal/invoices/{id}` — Retrieve an invoice
 * - `GET /customer-portal/mandates` — List the authenticated customer's Direct Debit mandates
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `422 unprocessable_entity` — business-rule failure (for example, refunding more than the original charge).
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const customerPortalMandatesReauthorizeVerifyOtp = <ThrowOnError extends boolean = false>(options: Options<CustomerPortalMandatesReauthorizeVerifyOtpData, ThrowOnError>) => (options.client ?? client).post<CustomerPortalMandatesReauthorizeVerifyOtpResponses, CustomerPortalMandatesReauthorizeVerifyOtpErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-portal/mandates/{id}/re-authorize/verify-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List a customer's meter usage
 *
 * Returns per-meter aggregates for a single customer. Requires a `customer_id` query parameter. For each meter the merchant has defined, the response includes the aggregate quantity (applying the meter's native aggregation function), the event count, and the most recent event timestamp.
 *
 * Use this to render a customer's current consumption snapshot in your own UI — for example, a usage dashboard showing "4,820 / 10,000 requests this period".
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /customer-meters/{customer_id}/{meter_id}` — Retrieve a customer-meter aggregate
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const customerMetersList = <ThrowOnError extends boolean = false>(options: Options<CustomerMetersListData, ThrowOnError>) => (options.client ?? client).get<CustomerMetersListResponses, CustomerMetersListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-meters',
    ...options
});

/**
 * Retrieve a customer-meter aggregate
 *
 * Returns a single customer-meter aggregate for the specified customer + meter pair. Returns 404 only if the meter itself does not exist on the merchant — if the meter exists but the customer has zero events, the response returns an aggregate with `total_quantity: 0`, `event_count: 0`, `last_event_at: null`.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /customer-meters` — List a customer's meter usage
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const customerMetersGet = <ThrowOnError extends boolean = false>(options: Options<CustomerMetersGetData, ThrowOnError>) => (options.client ?? client).get<CustomerMetersGetResponses, CustomerMetersGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/customer-meters/{customer_id}/{meter_id}',
    ...options
});

/**
 * List payment intents
 *
 * Returns a list of payment intents with optional filtering.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /payment-intents` — Create a payment intent
 * - `GET /payment-intents/{id}` — Retrieve a payment intent
 * - `POST /payment-intents/{id}` — Update a payment intent
 * - `POST /payment-intents/{id}/confirm` — Confirm a payment intent
 * - `POST /payment-intents/{id}/capture` — Capture a payment intent
 * - `POST /payment-intents/{id}/cancel` — Cancel a payment intent
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const paymentIntentsList = <ThrowOnError extends boolean = false>(options?: Options<PaymentIntentsListData, ThrowOnError>) => (options?.client ?? client).get<PaymentIntentsListResponses, PaymentIntentsListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-intents',
    ...options
});

/**
 * Create a payment intent
 *
 * Creates a payment intent to orchestrate payment collection with support for 3DS/SCA authentication.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /payment-intents` — List payment intents
 * - `GET /payment-intents/{id}` — Retrieve a payment intent
 * - `POST /payment-intents/{id}` — Update a payment intent
 * - `POST /payment-intents/{id}/confirm` — Confirm a payment intent
 * - `POST /payment-intents/{id}/capture` — Capture a payment intent
 * - `POST /payment-intents/{id}/cancel` — Cancel a payment intent
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const paymentIntentsCreate = <ThrowOnError extends boolean = false>(options?: Options<PaymentIntentsCreateData, ThrowOnError>) => (options?.client ?? client).post<PaymentIntentsCreateResponses, PaymentIntentsCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-intents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Retrieve a payment intent
 *
 * Retrieves a payment intent by its ID (pi_xxx).
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /payment-intents` — Create a payment intent
 * - `GET /payment-intents` — List payment intents
 * - `POST /payment-intents/{id}` — Update a payment intent
 * - `POST /payment-intents/{id}/confirm` — Confirm a payment intent
 * - `POST /payment-intents/{id}/capture` — Capture a payment intent
 * - `POST /payment-intents/{id}/cancel` — Cancel a payment intent
 *
 * **Common errors**
 *
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const paymentIntentsGet = <ThrowOnError extends boolean = false>(options: Options<PaymentIntentsGetData, ThrowOnError>) => (options.client ?? client).get<PaymentIntentsGetResponses, PaymentIntentsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-intents/{id}',
    ...options
});

/**
 * Confirm a payment intent
 *
 * Confirms the payment intent. May return requires_action if 3DS authentication is needed.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /payment-intents` — Create a payment intent
 * - `GET /payment-intents` — List payment intents
 * - `GET /payment-intents/{id}` — Retrieve a payment intent
 * - `POST /payment-intents/{id}` — Update a payment intent
 * - `POST /payment-intents/{id}/capture` — Capture a payment intent
 * - `POST /payment-intents/{id}/cancel` — Cancel a payment intent
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const paymentIntentsConfirm = <ThrowOnError extends boolean = false>(options: Options<PaymentIntentsConfirmData, ThrowOnError>) => (options.client ?? client).post<PaymentIntentsConfirmResponses, PaymentIntentsConfirmErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-intents/{id}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Capture a payment intent
 *
 * Captures a payment intent that was created with capture_method=manual.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /payment-intents` — Create a payment intent
 * - `GET /payment-intents` — List payment intents
 * - `GET /payment-intents/{id}` — Retrieve a payment intent
 * - `POST /payment-intents/{id}` — Update a payment intent
 * - `POST /payment-intents/{id}/confirm` — Confirm a payment intent
 * - `POST /payment-intents/{id}/cancel` — Cancel a payment intent
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const paymentIntentsCapture = <ThrowOnError extends boolean = false>(options: Options<PaymentIntentsCaptureData, ThrowOnError>) => (options.client ?? client).post<PaymentIntentsCaptureResponses, PaymentIntentsCaptureErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-intents/{id}/capture',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel a payment intent
 *
 * Cancels a payment intent. Cannot cancel if already succeeded or canceled.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /payment-intents` — Create a payment intent
 * - `GET /payment-intents` — List payment intents
 * - `GET /payment-intents/{id}` — Retrieve a payment intent
 * - `POST /payment-intents/{id}` — Update a payment intent
 * - `POST /payment-intents/{id}/confirm` — Confirm a payment intent
 * - `POST /payment-intents/{id}/capture` — Capture a payment intent
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const paymentIntentsCancel = <ThrowOnError extends boolean = false>(options: Options<PaymentIntentsCancelData, ThrowOnError>) => (options.client ?? client).post<PaymentIntentsCancelResponses, PaymentIntentsCancelErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/payment-intents/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List events
 *
 * Returns a list of events with optional filters. Events are returned in reverse chronological order.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /events/{id}` — Retrieve an event
 * - `POST /events/{id}/resend` — Resend webhook for an event
 * - `POST /events/test` — Create a test event
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const eventsList = <ThrowOnError extends boolean = false>(options?: Options<EventsListData, ThrowOnError>) => (options?.client ?? client).get<EventsListResponses, EventsListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/events',
    ...options
});

/**
 * Retrieve an event
 *
 * Retrieves the details of an event by its ID.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /events` — List events
 * - `POST /events/{id}/resend` — Resend webhook for an event
 * - `POST /events/test` — Create a test event
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const eventsGet = <ThrowOnError extends boolean = false>(options: Options<EventsGetData, ThrowOnError>) => (options.client ?? client).get<EventsGetResponses, EventsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/events/{id}',
    ...options
});

/**
 * Resend webhook for an event
 *
 * Queues the event to be resent to all configured webhook endpoints.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /events` — List events
 * - `GET /events/{id}` — Retrieve an event
 * - `POST /events/test` — Create a test event
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const eventsResend = <ThrowOnError extends boolean = false>(options: Options<EventsResendData, ThrowOnError>) => (options.client ?? client).post<EventsResendResponses, EventsResendErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/events/{id}/resend',
    ...options
});

/**
 * List entitlements
 *
 * Retrieve all entitlements for a customer. Pass `customer_id` as a query parameter. Includes computed access status based on subscription state.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /customers/{customerId}/entitlements` — List customer entitlements
 * - `POST /customers/{customerId}/entitlements` — Grant entitlement to customer
 * - `DELETE /customers/{customerId}/entitlements` — Revoke entitlement by benefit key
 * - `GET /customers/{customerId}/entitlements/check` — Check customer entitlement
 * - `DELETE /customers/{customerId}/entitlements/{entitlementId}` — Revoke entitlement by ID
 * - `GET /entitlements/check` — Check entitlement access
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const entitlementsList = <ThrowOnError extends boolean = false>(options: Options<EntitlementsListData, ThrowOnError>) => (options.client ?? client).get<EntitlementsListResponses, EntitlementsListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/entitlements',
    ...options
});

/**
 * Check entitlement access
 *
 * Check if a customer has access to a specific benefit by key. This is the primary endpoint for feature gating and licensing checks.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /customers/{customerId}/entitlements` — List customer entitlements
 * - `POST /customers/{customerId}/entitlements` — Grant entitlement to customer
 * - `DELETE /customers/{customerId}/entitlements` — Revoke entitlement by benefit key
 * - `GET /customers/{customerId}/entitlements/check` — Check customer entitlement
 * - `DELETE /customers/{customerId}/entitlements/{entitlementId}` — Revoke entitlement by ID
 * - `GET /entitlements` — List entitlements
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const entitlementsCheck = <ThrowOnError extends boolean = false>(options: Options<EntitlementsCheckData, ThrowOnError>) => (options.client ?? client).get<EntitlementsCheckResponses, EntitlementsCheckErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/entitlements/check',
    ...options
});

/**
 * List transactions
 *
 * List all transactions for the authenticated merchant. Transactions represent the unified financial truth — every sale, refund, void, capture, dispute, and adjustment.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /transactions/{id}` — Get transaction by ID
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const transactionsList = <ThrowOnError extends boolean = false>(options?: Options<TransactionsListData, ThrowOnError>) => (options?.client ?? client).get<TransactionsListResponses, TransactionsListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/transactions',
    ...options
});

/**
 * Get transaction by ID
 *
 * Retrieve a single transaction by its ID.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /transactions` — List transactions
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const transactionsGet = <ThrowOnError extends boolean = false>(options: Options<TransactionsGetData, ThrowOnError>) => (options.client ?? client).get<TransactionsGetResponses, TransactionsGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }, { scheme: 'bearer', type: 'http' }],
    url: '/transactions/{id}',
    ...options
});

/**
 * Look up a pending signed mandate request
 *
 * Public lookup of a pending signed mandate request by its emailed token. Rate-limited; returns 404 for unknown, consumed, cancelled, or expired tokens.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /dd/validate` — Validate a UK bank account for Direct Debit
 * - `POST /dd/preview` — Preview the Direct Debit collection date chain
 *
 * **Common errors**
 *
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `429 rate_limit_exceeded` — back off using the `Retry-After` header.
 */
export const ddMandateRequestsGet = <ThrowOnError extends boolean = false>(options: Options<DdMandateRequestsGetData, ThrowOnError>) => (options.client ?? client).get<DdMandateRequestsGetResponses, DdMandateRequestsGetErrors, ThrowOnError>({ url: '/dd/mandate-requests/{token}', ...options });

/**
 * Validate a UK bank account for Direct Debit
 *
 * Validates UK bank account details (sort code + account number) for Direct Debit eligibility with the bureau.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /dd/mandate-requests/{token}` — Look up a pending signed mandate request
 * - `POST /dd/preview` — Preview the Direct Debit collection date chain
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const ddValidate = <ThrowOnError extends boolean = false>(options?: Options<DdValidateData, ThrowOnError>) => (options?.client ?? client).post<DdValidateResponses, DdValidateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/dd/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Preview the Direct Debit collection date chain
 *
 * Returns the backend-owned working-day date chain (advance notice → submission → collection → settlement) for a Direct Debit collection. Clients never compute these dates.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /dd/mandate-requests/{token}` — Look up a pending signed mandate request
 * - `POST /dd/validate` — Validate a UK bank account for Direct Debit
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const ddPreview = <ThrowOnError extends boolean = false>(options?: Options<DdPreviewData, ThrowOnError>) => (options?.client ?? client).post<DdPreviewResponses, DdPreviewErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/dd/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List Direct Debit mandates
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /mandates` — Create a Direct Debit mandate
 * - `GET /mandates/{id}` — Retrieve a Direct Debit mandate
 * - `POST /mandates/{id}/cancel` — Cancel a Direct Debit mandate
 * - `POST /mandates/{id}/suspend` — Suspend a Direct Debit mandate
 * - `POST /mandates/{id}/reinstate` — Reinstate a suspended Direct Debit mandate
 * - `POST /mandates/{id}/collections` — Schedule a one-off Direct Debit collection
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 *
 * **Pagination**
 *
 * Offset-based with `limit` (default 25, max 100) and `offset`. The response `pagination` block includes `total` and `hasMore`. See [the pagination guide](/docs/fundamentals/pagination) for SDK auto-paging helpers.
 */
export const mandatesList = <ThrowOnError extends boolean = false>(options?: Options<MandatesListData, ThrowOnError>) => (options?.client ?? client).get<MandatesListResponses, MandatesListErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/mandates',
    ...options
});

/**
 * Create a Direct Debit mandate
 *
 * Creates a Direct Debit mandate for a customer. Bank details are validated with the bureau and stored KMS-encrypted; only masked values are returned.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `GET /mandates` — List Direct Debit mandates
 * - `GET /mandates/{id}` — Retrieve a Direct Debit mandate
 * - `POST /mandates/{id}/cancel` — Cancel a Direct Debit mandate
 * - `POST /mandates/{id}/suspend` — Suspend a Direct Debit mandate
 * - `POST /mandates/{id}/reinstate` — Reinstate a suspended Direct Debit mandate
 * - `POST /mandates/{id}/collections` — Schedule a one-off Direct Debit collection
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 * - `410 gone` — the resource has been archived or permanently deleted.
 * - `422 unprocessable_entity` — business-rule failure (for example, refunding more than the original charge).
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const mandatesCreate = <ThrowOnError extends boolean = false>(options: Options<MandatesCreateData, ThrowOnError>) => (options.client ?? client).post<MandatesCreateResponses, MandatesCreateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/mandates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve a Direct Debit mandate
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /mandates` — Create a Direct Debit mandate
 * - `GET /mandates` — List Direct Debit mandates
 * - `POST /mandates/{id}/cancel` — Cancel a Direct Debit mandate
 * - `POST /mandates/{id}/suspend` — Suspend a Direct Debit mandate
 * - `POST /mandates/{id}/reinstate` — Reinstate a suspended Direct Debit mandate
 * - `POST /mandates/{id}/collections` — Schedule a one-off Direct Debit collection
 *
 * **Common errors**
 *
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 */
export const mandatesGet = <ThrowOnError extends boolean = false>(options: Options<MandatesGetData, ThrowOnError>) => (options.client ?? client).get<MandatesGetResponses, MandatesGetErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/mandates/{id}',
    ...options
});

/**
 * Cancel a Direct Debit mandate
 *
 * Cancels a mandate. If it was lodged with the bureau, the London & Zurich customer is cancelled too.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /mandates` — Create a Direct Debit mandate
 * - `GET /mandates` — List Direct Debit mandates
 * - `GET /mandates/{id}` — Retrieve a Direct Debit mandate
 * - `POST /mandates/{id}/suspend` — Suspend a Direct Debit mandate
 * - `POST /mandates/{id}/reinstate` — Reinstate a suspended Direct Debit mandate
 * - `POST /mandates/{id}/collections` — Schedule a one-off Direct Debit collection
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const mandatesCancel = <ThrowOnError extends boolean = false>(options: Options<MandatesCancelData, ThrowOnError>) => (options.client ?? client).post<MandatesCancelResponses, MandatesCancelErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/mandates/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suspend a Direct Debit mandate
 *
 * Suspends an active (or pending-lodgement) mandate.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /mandates` — Create a Direct Debit mandate
 * - `GET /mandates` — List Direct Debit mandates
 * - `GET /mandates/{id}` — Retrieve a Direct Debit mandate
 * - `POST /mandates/{id}/cancel` — Cancel a Direct Debit mandate
 * - `POST /mandates/{id}/reinstate` — Reinstate a suspended Direct Debit mandate
 * - `POST /mandates/{id}/collections` — Schedule a one-off Direct Debit collection
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const mandatesSuspend = <ThrowOnError extends boolean = false>(options: Options<MandatesSuspendData, ThrowOnError>) => (options.client ?? client).post<MandatesSuspendResponses, MandatesSuspendErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/mandates/{id}/suspend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reinstate a suspended Direct Debit mandate
 *
 * Reinstates a suspended mandate. This is NOT a status flip — it re-lodges the mandate to Bacs (a new AUDDIS instruction) using the securely stored bank details, then moves the mandate to pending_lodgement (REV-3123).
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /mandates` — Create a Direct Debit mandate
 * - `GET /mandates` — List Direct Debit mandates
 * - `GET /mandates/{id}` — Retrieve a Direct Debit mandate
 * - `POST /mandates/{id}/cancel` — Cancel a Direct Debit mandate
 * - `POST /mandates/{id}/suspend` — Suspend a Direct Debit mandate
 * - `POST /mandates/{id}/collections` — Schedule a one-off Direct Debit collection
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 * - `422 unprocessable_entity` — business-rule failure (for example, refunding more than the original charge).
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const mandatesReinstate = <ThrowOnError extends boolean = false>(options: Options<MandatesReinstateData, ThrowOnError>) => (options.client ?? client).post<MandatesReinstateResponses, MandatesReinstateErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/mandates/{id}/reinstate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Schedule a one-off Direct Debit collection
 *
 * Schedules a one-off Bacs collection against an active mandate for an invoice or payment link. L&Z confirms the permitted collection date, the payer receives the configured regulatory advance notice first, and nothing is marked paid until the bureau confirms collection. Idempotent per source: retrying with the same sourceId returns or reconciles the same provider schedule instead of collecting twice.
 *
 * ---
 *
 * **Related endpoints**
 *
 * - `POST /mandates` — Create a Direct Debit mandate
 * - `GET /mandates` — List Direct Debit mandates
 * - `GET /mandates/{id}` — Retrieve a Direct Debit mandate
 * - `POST /mandates/{id}/cancel` — Cancel a Direct Debit mandate
 * - `POST /mandates/{id}/suspend` — Suspend a Direct Debit mandate
 * - `POST /mandates/{id}/reinstate` — Reinstate a suspended Direct Debit mandate
 *
 * **Common errors**
 *
 * - `400 invalid_request` — malformed payload or failed validation.
 * - `401 unauthenticated` — missing, malformed, or revoked API key.
 * - `403 permission_denied` — key lacks the required scope, or the resource belongs to a different merchant.
 * - `404 resource_missing` — the referenced resource does not exist or is not visible to your key.
 * - `409 conflict` — Idempotency-Key collision with a different body, or a concurrent state-transition conflict.
 * - `422 unprocessable_entity` — business-rule failure (for example, refunding more than the original charge).
 *
 * **Idempotency**
 *
 * Pass an `Idempotency-Key` header (UUID v4 recommended) to make retries safe. Keys are valid for 24 hours; see [the idempotency guide](/docs/fundamentals/idempotency).
 */
export const mandatesScheduleCollection = <ThrowOnError extends boolean = false>(options: Options<MandatesScheduleCollectionData, ThrowOnError>) => (options.client ?? client).post<MandatesScheduleCollectionResponses, MandatesScheduleCollectionErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/mandates/{id}/collections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
